
module.exports = {
    en: {
        general: {
            downloadFrom: "Download From",
            brandsLabel: "Brands",
            NotFoundTitle: "Sorry, something went wrong",
            NotFoundSubtitle: "The page you are looking for might have been removed had its name changed or is temporarily unavailable.",
            NotFoundbuttonText: "Go To Homepage",
            NoAccessTitle: "Inaccessible advertisement",
            NoAccessSubtitle: "It looks like this advertisement does not belong to your company or the ad does not exist.",
            UnauthorizedTitle: "Not authorized",
            UnauthorizedSubtitle: "You do not have permission to access the auditing module. Please contact your account manager if you need access."
        },
        login: {
            title: "Login your account",
            email: "Email Address",
            password: "Password",
            login: "Login",
            signing: "Signing...",
            accountYesOrNot: "Don't have an account? ",
            register: "Register",
            loaded: "Loaded",
            none: "None",
            loading: "Loading",
            loginSuccessful: "Login successful. Welcome!",
            loginError: " Login error!",
            invalidCredentials: "Invalid credentials",
            failed: "There was an error in the Login",
            notAvailable: "Service not available",
            saving: 'Saving...',
            saved: 'The changes were saved.',
            editError: 'There was an error editing your profile.',
        },
        signUp: {
            signUp: "Sign Up",
            email: "Email",
            password: "Password",
            specificationPassword: "The password must contain at least: A length between 6 and 15 characters, at least one uppercase letter and one lowercase letter, one number and one special character.",
            confirmPassword: "Confirm password",
            loading: "Loading...",
            uploading: "Uploading ",
            failed: "There was an error in the Sign Up",
            notAvailable: "Service not available",
            none: "None",
            createYourAccount: "Create your account",
            addYourCompany: "Add your company",
            alreadyHaveAccount: "Already have an account? ",
            existEmail: "The email entered already exists.",
            existCompanyName: 'The company name already exists.',
            companyName: 'Company Name *',
            cellPhone: 'Cell Phone *',
            uploadLogo: 'Upload Logo (PNG or JPEG)',
            photoError: 'Please upload a valid image file (PNG or JPEG).',
            editPhoto: 'Edit photo',
            deletePhoto: 'Delete photo',
            iAgree: 'I agree to the ',
            termsAndConditions: 'Terms & Conditions',
            shouldAcceptTAndC: 'You should accept terms & conditions',
            createCompany: 'Create company',
            signUpSuccessful: "Sign Up successful. Welcome!",
            signUpError: " Sign Up error!",
            specificationCellPhone: "No spaces or hyphens allowed.",
            createCompanySuccessful: 'You have created your company, congratulations!',
            createCompanyError: 'Error adding your company!'
        },
        editCompany: {
            saving: 'Saving...',
            saved: 'The changes were saved.',
            editError: 'There was an error editing your company.',
            editTitle: 'Edit company information',
            title: 'Company information',
            companyName: 'Company Name',
            cellPhone: 'Cell Phone',
            uploadLogo: 'Upload Logo (PNG or JPEG)',
            photoError: 'Please upload a valid image file (PNG or JPEG).',
            editPhoto: 'Edit photo',
            deletePhoto: 'Delete photo',
            uploading: "Uploading ",
            save: "Save",
            cancel: "Cancel",
            editInformation: 'Edit information',
            goToProfilInformation: 'go to profile information',
        },
        editProfile: {
            editTitle: 'Edit user information',
            title: 'User information',
            firstName: 'First name',
            lastName: 'Last Name',
            email: 'Email',
            save: "Save",
            cancel: "Cancel",
            editInformation: 'Edit information',
            addCompany: 'Add company',
            goToCompanyInformation: 'Go to Company information',
            saved: 'The changes were saved.',
            goBackMyPortal: 'Return to my business portal',
            myPortal: 'Go to my business portal'
        },
        audtiAdvertisemnt: {
            approve: 'Approve',
            reject: 'Reject',
            pending: 'Pending advertisement',
            approvedAd: 'Approved advertisement',
            rejectedAd: 'rejected advertisement',
            brief: 'Brief',
            termsAndConditions: 'Details and participation conditions',
            validate: 'Validate',
            willBePaidWith: 'Ad will be paid with ',
            creation: 'Creation ',
            campaignType: 'Campaign Type ',
            creatorUser: 'Creator User ',
            showSnackbarApproved: 'The advertisement was successfully approved.',
            showSnackbarRejected: 'The advertisement was successfully rejected.',
            youAreInAudit: 'You are in the Adme audit module',
            areYouSureToReject: 'Are you sure you want to reject this Advertisement?'
        },
        download: {
            copiedSuccessful: "Referral code copied!",
            title: 'In Adme everyone is an influencer',
            subtitle: 'Adme is the app that connects you with advertising campaigns and lets you earn rewards for participating in them. More than just an app, it’s your portal to a new way of generating content and being rewarded for it.',
            downloadTitle: 'Discover Adme',
            downloadSubtitle: 'Use this referral code to create your account:',
            preLunchdownloadSubtitle: 'We haven\'t launched yet, but don\'t worry, you\'ll find a referral code here as soon as we announce the launch.',
            bodyTitle: 'How to get started?',
            bodySubtitle: 'Follow these simple steps to start earning with Adme.',
            step1Title: 'Download the App',
            step1Subtitle: 'Click the button above and start enjoying Adme.',
            step2Title: 'Enter a referral code',
            step2Subtitle: 'You can either copy this code or use a friend’s code if they’ve already downloaded it.',
            step2SubtitlePreLunch: 'Once we launch, you’ll see a code that you can copy instantly.',
            step3Title: 'Sign up',
            step3Subtitle: 'Fill in the necessary information so we can provide you with campaigns that fit your profile.',
            step4Title: 'Link your social media accounts',
            step4Subtitle: 'This way, you´ll be able to automatically post the content you want on them through Adme.',
            step5Title: 'Select a campaign',
            step5Subtitle: 'Campaigns may include some guidelines, or allow you to create content freely.',
            step6Title: 'Publish and receive your reward',
            step6Subtitle: 'After posting, you will receive your reward. Depending on the campaign, you’ll be rewarded with money, products, or discounts.',
            download: 'Download'
        },
        downloadAppRedirector: {
            title: 'Redirecting to the store: ',
            subtitle: 'Thanks for the interest in Adme 🙌',
        },
        childsafetystandards: {
            title: 'Child Safety Policy for Adme Corp',
            titleParagraph1: '1. Commitment Against Child Sexual Exploitation',
            paragraph1: 'At Adme ($), we are committed to protecting minors and strictly prohibit any content that promotes or tolerates the sexual exploitation of children.',
            titleParagraph2: '2. Prohibited Content and Behavior',
            paragraph20: '- Any form of child pornography or sexually explicit material involving minors.',
            paragraph21: '- Content that promotes, encourages, or depicts sexual activities with minors.',
            paragraph22: '- Interactions in which an adult attempts to exploit or harm a minor in any way.',
            titleParagraph3: '3. Reporting and Complaint Mechanism',
            paragraph3: 'If you encounter inappropriate content or suspect any behavior that endangers a minor, please report it immediately to our safety team by sending an email to: info@adme.com.ar',
            titleParagraph4: '4. Investigation and Response',
            paragraph4: 'Our team will review every report and take immediate action. This may include removing the content, suspending the involved account, and notifying the appropriate legal authorities if necessary.',
            titleParagraph5: '5. Cooperation with Authorities',
            paragraph5: 'We work closely with legal authorities whenever a report involves child sexual abuse or exploitation. We provide relevant information in compliance with local and international legislation.',
            titleParagraph6: '6. Contact',
            paragraph6: 'For any inquiries or reports related to child safety, please contact us at: info@adme.com.ar',
            footer: 'Last Updated: 01/25/2025'
        },
        brands: {
            whatIsAdme: {
                whatIsAdme: 'What is Adme?',
                description: 'Adme is the first platform that connects your brand with social media users, turning their posts into your most powerful advertising: viral word of mouth.',
                bullet1Title: 'Authentic Advertising',
                bullet1: 'Turn your customers into your best ambassadors by letting them recommend you. Reach new audiences every day with genuine, user-generated content.',
                bullet2Title: 'Budget Control',
                bullet2: 'You decide how much to pay for each post and how to do it—whether with money, products, or discounts. Choose the total budget or inventory for your campaign.',
                bullet3Title: 'Transparent, Real-Time Metrics',
                bullet3: 'Create campaigns in under 5 minutes and easily track the effectiveness of your online presence in real time.',
                brands: 'Brands',
                downloads: 'Downloads',
                startNow: 'Get started NOW',
                viewConcept: 'Watch the concept'
            },
            howTostart: {
                title: 'How to get started?',
                stepsDescriptions: 'To link your brand with Adme and start revolutionizing your influencer marketing strategies, simply follow these steps. It is completely free:',
                questionBeforeToStart: `Do you have any questions before we start? `,
                promo: 'If you join before 11/30, you will enjoy a 0% commission for the first 6 months',
                registerTitle: 'Sign up',
                registerOKTitle: 'Registered',
                registerOKSubtitle: 'You’ve registered, congratulations!',
                registerOkProfileComplete: 'Complete Profile',
                registerOkProfile: 'View Profile',
                registerSubtitle: 'Join in a few seconds.',
                addCompanyTitle: 'Add my business',
                addCompanySubtitle: 'You are just one step away from being ready.',
                addCompanyOkTitle: 'Company added',
                addCompanyOkSubtitle: '. You are part of Adme!',
                addCompanyOkUploadLogo: 'Upload logo',
                addCompanyOkProfile: 'View my business details',
                createCampaignTitle: 'Design my campaign',
                createCampaignSubtitle: 'Contact your agent to help you design your campaign.',
                createCampaignO3Title: 'You already have campaigns.',
                createCampaignOk1Subtitle: 'You’re all set to contact an advisor or you can also:',
                createCampaignOk2Subtitle: 'Contact an agent to shape your campaign or advise you.',
                createCampaignOk3Subtitle: 'Do you want to create another one campaign?',
                promoPart2: ' 0% commission ',
                promoPart3: 'for the first 6 months.',
                promoOkPart1: 'Enjoy ',
                promoOkPart2: ' 0% commission ',
                promoOkPart3: 'on your account for the next 6 months, already activated for your business!',
                goToMyCampaigns: 'Go to my campaigns',
                preDesign: 'Pre-design your future campaign',
                chatWhitUs: 'Contact an advisor',
                planEnterprise: 'Enterprise Plan contact us',
                img: 'assets/img/free3months.png'
            },
            howToWork: {
                Title: 'How does it work?',
                subtitle: 'Adme connects you with people who can genuinely promote your products and services through their social media networks.',
                step1Title: 'Campaign launch',
                step1Subtitle: 'Launch a campaign on Adme, defining your objectives and the type of content you want.',
                step2Title: 'Content creation by users',
                step2Subtitle: 'Adme users create and share content aligned with your campaign, reaching their personal social networks.',
                step3Title: 'Validation and reward',
                step3Subtitle: 'Each post is audited to ensure its quality and relevance, after which the user receives their reward.',
            },
            plansAndPrices: {
                title: 'Plans and prices',
                subtitle: 'Flexibility and Exclusivity',
                paragraph1: 'At Adme, we understand that each brand is unique, which is why we offer you total freedom to choose how to reward influencers. Do you prefer to pay in cash, or with exclusive products, discounts, or unique experiences? The choice is yours.',
                paragraph21: 'By joining Adme, the campaigns where you choose to reward with money will always be free: ',
                paragraph22: 'NO SERVICE FEES EVER. ',
                paragraph23: 'You set your campaign´s budget just once, and Adme will handle the payments to those who execute your campaign.',
                paragraph3: 'Campaigns where you choose to reward with a product or discount will also have no service fees during the first 3 months after our launch. After this period, the service fee will be a percentage of the product’s value you’re offering for execution.',
                paragraph4: 'Join now and be part of a new era in digital marketing, where your investment has a real and direct impact.',
            },
            valueProposition: {
                title: 'Our value proposition',
                subtitle: 'For brands, Adme represents an opportunity to access genuine and diverse content, expanding their reach and impact on social media. Through our platform, brands can:',
                step1Title: 'Launch advertising campaigns',
                step1Subtitle: 'Your campaigns will be designed just once, quickly and with assistance.',
                step2Title: 'Be advertised on social media with authentic content',
                step2Subtitle: 'Your brand will receive original content generated and shared on their networks by those who use your products.',
                step3Title: 'Reach those who do not yet consume the brand',
                step3Subtitle: 'Every user who has the Adme app downloaded will discover your brand, as they will see your campaign ready to launch.',
                step4Title: 'Connect with a wide network of influencers and users',
                step4Subtitle: 'At Adme, anyone can be an influencer, from those who already monetize their content to those who have not yet done so.',
                step5Title: 'Monitor your campaigns in real time',
                step5Subtitle: 'With Adme, you will have full access to all the information about your campaigns.',
                step6Title: 'Control how to reward influencers',
                step6Subtitle: 'Decide what and how much you want to offer for each piece of content created, whether in money, products, or discounts.',
            }
        },
        header: {
            menu: {
                about: 'About',
                process: 'Process',
                features: 'Features',
                passiveIncomes: "Passive incomes",
                brands: 'Brands',
                agencies: 'Agencies',
                investors: 'Investors',
                companies: 'Companies',
                campaigns: 'Campaigns',
                web3: 'Web3',
                logout: 'logout',
                signUp: 'SignUp',
                addCompany: 'Add company',
                profile: 'Profile',
                login: 'Login',
                registerMyBusiness: "Sign up my business",
                myPortal: "My business portal",
                myPortalHome: "Main"
            },
        },
        hero: {
            title: "Adme transforms your posts into income",
            subtitle: "At Adme, you are an Influencer. Use the app to post on Instagram, and receive your payment each time you do.",
            videoUrl: "https://www.youtube.com/watch?v=ZpkI--1X8UI",
        },
        about: {
            title: 'Why is Adme different?',
            subtitle: 'Adme recognizes you as the main protagonist in the world of social media. No matter how many friends or followers you have on your social networks, Adme considers you an Influencer and pays you for it.',
            reason1Title: 'Your photo, your money',
            reason1Subtitle: "If you're the one creating the photos and paying for the products and services displayed in them, why not get paid for sharing them? Adme makes it possible!",
            reason2Title: 'Post from a single app',
            reason2Subtitle: "With the Adme app, you can share photos on your social media and earn money from them by choosing to sponsor them.",
            reason3Title: 'Passive Income',
            reason3Subtitle: 'Adme pays you a percentage of the money that your referrals and your referrals’ referrals continuously earn. This way, you generate passive income.'
        },
        counters: {
            socialNetworksConnected: "Social Networks connected",
            betaTesterUsers: "Users using the app",
            betaTesterBrands: "Brans advertising in Adme",
            currencyIntegrated: "Currencies integrated"

        },
        process: {
            title: "Monetizing with Adme is very easy",
            subtitle: "Adme brings you advertising campaigns from many brands looking for people like you to promote their products and services.",
            stepsImage: "assets/img/adme-mobile-process-to-influencers.png",
            step1Title: "Take a selfie",
            step1Subtitle: "Snap the photo as you usually would.",
            step2Title: "Sponsor and share it",
            step2Subtitle: "Before posting it on your social networks, associate the photo with an advertising campaign for a product or service that appears in it.",
            step3Title: "Receive your reward",
            step3Subtitle: "Once your photo is evaluated and approved, you will receive your reward.",
        },
        passiveIncomes: {
            title: "Passive Income",
            subtitle: "With Adme, you not only make money by sharing your photos, but also you earn money passively",
            method1Title: "The Best Referral Program",
            method1Subtitle: "Anyone who joins Adme thanks to your invitation, or the invitation of your referrals, will be part of your clan. The great thing is that all of them (no matter how deep they are in your referral network) will help you earn money, as Adme rewards you with a percentage of their earnings.",
            method2Title: "The impact of your photos",
            method2Subtitle: "After receiving payment for your photo, you will continue earning money based on its succes. Adme pays you for each \"like\", comment and other reactions on your post.",
            method3Title: "",
            method3Subtitle: "",
            method4Title: "",
            method4Subtitle: "",
        },
        features: {
            title: "Adme Features",
            subtitle: "Adme is the first platform that believes all social network users are influencers. For this reason, Adme translates the benefits that brands gain from with the genuine influence of your photos into monetary rewards for content creators like you! 🤟",
            feature1Title: "One app for all your social networks",
            feature1Subtitle: "With the Adme app you can post on all your linked social networks at the same time. 📱",
            feature2Title: "Sponsor your photos",
            feature2Subtitle: "f the photo you are about to post features a product, service, or place, you can earn money by sponsoring it through an advertising campaign. 💰💰💰",
            feature3Title: "Create photos on demand",
            feature3Subtitle: "You can also earn money by creating and sharing photos based on the specifications of an advertising campaign that appeals to you. 💰💰💰",
            feature4Title: "Share Advertising Spots",
            feature4Subtitle: "You can also earn money by sharing advertising spot images created by brands. 💰💰💰",
            feature5Title: "More likes, more earnings",
            feature5Subtitle: "After earning money by posting a sponsored photo, you keep increasing your earnings based on its success. Adme pays you not only for the photos themselves but also for every like, comment, and other reaction they receive.  💰💰💰",
            feature6Title: "Earn money from your referral network",
            feature6Subtitle: "Every time your referrals or your referrals' referrals earn money, you will also earn a percentage of it. 💰💰💰",
        },
        testimonials: {
            title: "What Social Network Users Say About Adme",
            subtitle: "Adme understands that every user of social networks simply by sharing a satisfactory experience is influencing their friends and followers to consume the same products and services. So, if the brands benefit from it, why not reward the protagonists of this story?",
            testimonial1Name: "Giselle Yaccuzzy",
            testimonial1Title: "Facebook and Instagram user",
            testimonial1Testimony: "It is very exciting that an application like Adme pays me for uploading photos to my usual social networks, simply because it understands that I influence my friends and followers! 😍",
            testimonial2Name: "Maria Fernanda Iglesias",
            testimonial2Title: "Actriz. (@marifernandai) • Instagram",
            testimonial2Testimony: "",
            testimonial3Name: "Gonzalo Abadie",
            testimonial3Title: "Actor, (@Gonzactor) • Twitter",
            testimonial3Testimony: "",
            testimonial4Name: "",
            testimonial4Title: "",
            testimonial4Testimony: "",
        },
        faq: {
            title: "Frequently Asked Questions",
            subtitle1: "We know it sounds unbelievable that a social network pays its users, but it's real. Adme does it!",
            subtitle2: "If you have any questions, we're here to help. Send us a message!",
            q1Question: "Do I have to pay to use the app? 🙌",
            q1Answer: "Adme is 100% free, because the only goal is for you to earn products or money with your content and with the content your referrals generate.",
            q2Question: "Can I earn money with my social media? 💵",
            q2Answer: "Yes, by linking Adme to your Instagram account, you can post photos just like you normally do — but with the chance to earn money for it. Adme automatically publishes your content to your social media with the @ and # of each advertising campaign",
            q3Question: "What's the purpose of the referral code? 🏂",
            q3Answer: "To sign up for Adme, you need a referral code. And then as a user, you'll also have your own code, which allows you to earn 5% of the earnings your referrals generate through their activity on the app. Once you have your code, share it with friends, at gatherings, or post it on your social media.",
            q4Question: "What kind of content can I create? 📸",
            q4Answer: "Every post is different, that's why Adme offers three types of campaigns for different moments and ways to share. You can snap a photo based on campaign guidelines, match a spontaneous pic to an available campaign, or post brand-created content.",
            q5Question: "Do \"likes\" or reactions on my photos make a difference? ❤️",
            q5Answer: "Absolutely! With Adme, you earn not just for posting, but also for how well your content performs. The more engagement your post gets — likes, comments, and interactions — the more you can earn",
            q6Question: "How do I receive my rewards? 🤝",
            q6Answer: "You can earn rewards in the form of products or discounts in real time. You can also receive cash rewards through monthly payments sent to the account you've set up in your user profile.",
        },
        footer: {
            subscribe: {
                title: "If you have a brand, join Adme",
                subtitle: "and get exclusive benefits for your brand",
                placeholder: "enter your IG",
            },
            corp: {
                subtitle: "The disruptive platform that is changing the social media advertising paradigm."
            },
            products: {
                title: "Products",
                title2: "web portal",
                p1: "Adme Mobile App",
                p2: "Launch a campaign",
                p3: "adme.com.ar",
                p4: "Social media"
            },
            company: {
                title: "Company",
                section1: "About Us",
                section2: "Community",
                section3: "Invest in Adme",
                section4: "Work with us"
            },
            support: {
                title: "Support",
                s1: "FAQ",
            },
            rights: "Adme, All rights reserved",
            contactAgent: 'Contact an agent'

        },
        commingSoonInvestors: {
            title: "We're Coming Soon",
            subtitle: "The Adme website for Investors is under construction. We'll be here soon with our new awesome site, subscribe to be notified.",
            placeholder: "Enter your email",
        },
        commingSoonBrands: {
            title: "We're Coming Soon",
            subtitle: "The Adme website for Brands and Agencies is under construction. We'll be here soon with our new awesome site, subscribe to be notified.",
            placeholder: "Enter your email",
        },
        team: {
            sections: {
                cofounders: {
                    title: "Our Founders",
                    subtitle: "Fun, creativity from the impediments, failing early to reach success, are some of the values that the Ruiz Diaz brothers, our founders, promote and that justify Adme being so disruptive for the advertising market on social networks."
                },
                footer: {
                    theTeamTitle: "We're a lateral thinking team",
                    theTeamSubtitle: "Meet the creative brains behind Adme",
                    hereButtonLabel: "here"
                }
            },
            gaston: {
                fullName: "Gastón Ruiz Diaz",
                role: "Co-Founder",
                roleDescription: "Gaston and his brother, Mario Ruiz Diaz are the Co-Founder of the new generation of social medias, Adme",
                techRole: "Full Stack Developer",
                techRoleDescription: "Bachelor Degree in Computer Engineering with more than 15 years in the industry of building software",
                personalityDescription: "",
                phone: "+54 911 4085-1807",
                email: "gaston@adme.com.ar",
                picturePath: "gaston500x500.jpg",
                linkedinURL: "https://www.linkedin.com/in/gaston-ruiz-diaz-157366bb/"
            },
            mario: {
                fullName: "Mario Ruiz Diaz",
                role: "Co-Founder",
                roleDescription: "Mario and his brother, Gastón Ruiz Diaz are the Co-Founder of the new generation of social medias, Adme",
                techRole: "Full Stack Developer",
                techRoleDescription: "Bachelor Degree in Computer Engineering with more than 18 years in the industry of building software",
                personalityDescription: "",
                phone: "+54 911 4085-1807",
                email: "gaston@adme.com.ar",
                picturePath: "Mario.jpg",
                linkedinURL: "https://www.linkedin.com/in/marioruizdiaz/"
            },
            yulian: {
                fullName: "Julio Aranda",
                role: "Software Engineer",
                roleDescription: "Julio is one of of the people that is creating the new generation of social medias, Adme",
                personalityDescription: "",
                phone: "+54 911 5139-4412",
                email: "julio.aranda@adme.com.ar",
                picturePath: "yulian500x500.jpeg",
                linkedinURL: "https://www.linkedin.com/in/julioarandadev/"
            },
            alex: {
                fullName: "Alexander Paez Yepez",
                role: "Quality Assurance",
                roleDescription: "Alex is one of of the people that is creating the new generation of social medias, Adme",
                personalityDescription: "",
                phone: "+54 911 4085-1807",
                email: "alex.paez@adme.com.ar",
                picturePath: "alex.jpg",
                linkedinURL: "https://www.linkedin.com/in/alexander-paez/"
            },
            guille: {
                fullName: "Guillermina Diaz",
                role: "Quality Assurance",
                roleDescription: "Guille is one of of the people that is creating the new generation of social medias, Adme",
                personalityDescription: "",
                phone: "+54 911 4085-1807",
                email: "guillermina.diaz@adme.com.ar",
                picturePath: "guille.jpg",
                linkedinURL: "https://www.linkedin.com/in/guillermina-d%C3%ADaz-57a11337/"
            },
            javy: {
                fullName: "Javier Andriani",
                role: "Quality Assurance",
                roleDescription: "Javy is one of of the people that is creating the new generation of social medias, Adme",
                personalityDescription: "",
                phone: "+54 911 4085-1807",
                email: "javier.andriani@adme.com.ar",
                picturePath: "javy.jpg",
                linkedinURL: "https://www.linkedin.com/in/javierandrianiqcanalyst/"
            },
            fer: {
                fullName: "Fernando Messala",
                role: "Marketing Specialist",
                roleDescription: "Fer is one of of the people that is creating the new generation of social medias, Adme",
                personalityDescription: "",
                phone: "+54 911 4085-1807",
                email: "fernando.messala@adme.com.ar",
                picturePath: "fer.jpg",
                linkedinURL: "https://www.linkedin.com/in/fernando-messala/"
            },
            nico: {
                fullName: "Nicolas Carosio",
                role: "IT Specialist",
                roleDescription: "Nico is one of of the people that is creating the new generation of social medias, Adme",
                personalityDescription: "",
                phone: "+54 911 4085-1807",
                email: "nicoas.carosio@adme.com.ar",
                picturePath: "nico.jpg",
                linkedinURL: "https://www.linkedin.com/in/nicolas-carosio-13096615/"
            },
            jazmin: {
                fullName: "Jazmin Diaz",
                role: "Head of Image and Digital Strategy",
                roleDescription: "Responsible for managing Adme's brand image and designing and executing the social media strategy to engage with the end user. Develops creative campaigns that reflect the brand identity, driving growth and enhancing digital presence. Collaborates on the creation of relevant and engaging content, ensuring key messages effectively reach the target audience. Additionally, manages and optimizes user interaction across various digital platforms, with a focus on improving customer experience and fostering loyalty.",
                personalityDescription: "",
                phone: "",
                email: "jazmin.diaz@adme.com.ar",
                picturePath: "jazmin.jpg",
                linkedinURL: "https://www.linkedin.com"
            },
            luis: {
                fullName: "Luis, Da Silva",
                role: "Quality Assurance",
                roleDescription: "Luis is one of of the people that is creating the new generation of social medias, Adme",
                personalityDescription: "",
                phone: "",
                email: "luis@adme.com.ar",
                picturePath: "luis.jpg",
                linkedinURL: "https://www.linkedin.com/in/qaluiscarlosdasilva1/"
            },
        },
        guides: {
            title: "Get ready to make money with Adme",
            breadcrumbTitle: "Guides",
            grid: {

            },
            ios: {
                install: {
                    title: "iOS Guide",
                    subTitle: "Step by step guide to get Adme working in yor iPhone",
                    smallCard: {
                        title: "Install adme app in iPhone",
                        subtitle: "Step by Step instalation guide to start using adme app in iPhone.",

                    },
                    step1: {
                        title: "1. Download TestFlight ",
                        subtitle: "",
                        subSteps: {
                            a: "Go to ",
                            b: "Install this app",
                            c: "Grant the necessary permissions",
                            d: "",
                            e: ""
                        }
                    },
                    step2: {
                        title: "2. Join to Adme Beta Testers ",
                        subtitle: "After testFlight instalation...",
                        subSteps: {
                            a: "Join as a Beta!",
                            b: "",
                            c: "",
                            d: ""
                        }
                    },
                    step3: {
                        title: "3. Install the App ",
                        subtitle: "",
                        subSteps: {
                            a: "Press intall",
                            b: "Then press Open",
                            c: "Welcome to Adme!",
                            d: "",
                            e: ""
                        }
                    },
                    step4: {
                        title: "4. Welcome to Adme",
                        subtitle: "After installation, do the following.",
                        subSteps: {
                            a: "Sign Up",
                            b: "Complete user preferences and link your Social Medias."
                        }
                    },
                    step5: {
                        title: "5. Sign Up",
                        subtitle: "Since this is the first time you are going to use Adme, it required to create an user account",
                        subSteps: {
                            a: "Touch the \"Sign Up\" button.",
                            b: "Enter the following code \"9CD4CD95\" and press next.",
                            c: "Define an e-mail.",
                            d: "Insert a password for Adme."
                        }
                    },
                    step6: {
                        title: "6. Link your Facebook account",
                        subtitle: "In order to start posting in your Facebook account, it is needed to link your account",
                        subSteps: {
                            a: "Touch the Facebook switch.",
                            b: "Enter your email and password that you use to login in Facebook.",
                            c: "If the application asks you for any validation, complete it until the linking is finished.",
                            d: ""
                        }
                    },
                    step7: {
                        title: "7. Basic information",
                        subtitle: "In order to let you get Advertising Campaign according to your preferences, it is needed to complete the following info.",
                        subSteps: {
                            a: "Fill the Categories of interest, Gender, Country, State and City.",
                            b: "Scroll to the bottom and press the 'SAVE' button.",
                            c: "And finally, touch the home button 🏠",
                            d: ""
                        }
                    },
                    step8: {
                        title: "8. Congrats!",
                        subtitle: "You are ready to start making money with Adme!",
                        subSteps: {
                            a: "",
                            b: "",
                            c: "",
                            d: ""
                        }
                    }

                }
            },
            android: {
                install: {
                    title: "Android Guide",
                    subTitle: "Step by step guide to get Adme working in yor Android Phone.",
                    smallCard: {
                        title: "Install adme app in Android.",
                        subtitle: "Step by Step instalation guide to start using adme app in Android.",

                    },
                    step1: {
                        title: "1. Download Adme from Play Store.",
                        subtitle: "Adme is not yet included in the Store search",
                        subSteps: {
                            a: "Use this link  ",
                            b: "Click on 'Become a tester' button",
                            c: "Welcome to the testing program!",
                            d: ""
                        }
                    },
                    step2: {
                        title: "2. Install Adme app.",
                        subtitle: "* Press \" download it on Google Play\".",
                        subSteps: {
                            a: "Then press install...",
                            b: "Finally press 'Open' button."
                        }
                    },
                    step3: {
                        title: "3. Sign Up",
                        subtitle: "Since this is the first time you are going to use Adme, it required to create an user account",
                        subSteps: {
                            a: "Touch the \"Sign Up\" button.",
                            b: "Enter the following code \"9CD4CD95\" and press next.",
                            c: "Define an e-mail.",
                            d: "Insert a password for Adme."
                        }
                    },
                    step4: {
                        title: "4. Link your Facebook account",
                        subtitle: "In order to start posting in your Facebook account, it is needed to link your account",
                        subSteps: {
                            a: "Touch the Facebook switch.",
                            b: "Enter your email and password that you use to login in Facebook.",
                            c: "If the application asks you for any validation, complete it until the linking is finished.",
                            d: ""
                        }
                    },
                    step5: {
                        title: "5. Basic information",
                        subtitle: "In order to let you get Advertising Campaign according to your preferences, it is needed to complete the following info",
                        subSteps: {
                            a: "Fill the Categories of interest, Gender, Country, State and City.",
                            b: "Scroll to the bottom and press the 'SAVE' button.",
                            c: "And finally, touch the home button 🏠",
                            d: ""
                        }
                    },
                    step6: {
                        title: "6. Congrats!",
                        subtitle: "You are ready to use Adme!",
                        subSteps: {
                            a: "",
                            b: "",
                            c: "",
                            d: ""
                        }
                    }

                }
            },
            buttons: {
                readMore: "Read more",
                next: "Next",
                downloadNow: "Download Now"
            }

        },
        results: {
            companies: {
                hero: {
                    title: "Launched campaigns by Brands",
                    subtitle: "Companies usging Adme",
                },
                items: {
                    kpis: {
                        onGoingTitle: "Active campaigns",
                    },
                    buttons: {
                        goToCompaigns: "Go to Campaigns"
                    }
                }

            },
            company: {
                hero: {
                    subtitle: "Activities and results of campaings in Adme",
                },

            },
            campaign: {
                hero: {
                    title: "Campaign Results",
                    state: "State: ",
                    draft: "Draft",
                    onGoing: "Active",
                    stopped: "Stopped",
                    finished: "Finished",
                    typeOfCampaign: "Campaign Type: ",
                    spot: "Spot: In this campaign, you provided the content (such as photos or videos) from your Brand, and users only need to share it. This content is automatically posted to their social media profiles through Adme.",
                    sponsorship: "Sponsorship Campaigns: In these campaigns, your brand sponsors spontaneous user posts on social media, using organic content generated by users that aligns with your brand and campaign goals​.",
                    advertising: "Advertising: When creating this campaign, you set clear guidelines for the content influencers should create. Users must follow these instructions to ensure the shared content reflects the campaign’s intended messages and visual identity.",
                    youArePayingPart1: "You are rewarding each photo with ",
                    youArePayingPart21: "money: ",
                    youArePayingPart22: ": ",
                    youArePayingWithMoney: "You will pay users with money for executing your advertising campaign through Adme. Payment will be made after Adme audits the content of the posts.",
                    youArePayingWitProduct: "You will reward users with products, discounts, or promotions.",
                    youArePayingFooter: "This approach ensures that users are only rewarded when the advertising action has been correctly executed and after the appropriate audit according to the type of campaign.",
                    advertisingCampaignConditions: {
                        title: "Terms and Conditions",
                        advertising: "Your campaign is of the Advertising type, which means the necessary conditions for its execution were outlined in the brief. This document includes specific requirements to ensure that the ads created by users align with your brand’s objectives and values.",
                        sponsorshipTitle: "In Sponsorship campaigns, although spontaneous moments shared by users are encouraged, it is essential to maintain certain quality standards to ensure that the content adequately reflects your brand. The key conditions for content approval include:",
                        sponsorshipItem1: "Clarity and sharpness: Photos should not be blurry, shaky, or out of focus.",
                        sponsorshipitem2: "Good lighting: Images should be well-lit to ensure that the main elements are clearly visible.",
                        spot: "The content for this campaign was provided by your business at the time of its creation. When the user executes the ad, this content will be automatically posted on their social media. Since the user only needs to execute the campaign, they are not subject to an audit, as the photo uploaded by your brand will be automatically published on their profiles. But it is subject to validation."
                    },
                    brief: "Brief",
                    money: "Available money: ",
                    stock: "Stock of rewards :  ",
                    of: " of ",
                    spend: "Spend: ",
                    stockAvailable: "Stock of rewards ",
                    audit: {
                        title: "Audit / validation",
                        money: "Since this is a money-paid campaign, the execution must pass Adme's audit. Adme is responsible for verifying that the content meets the requirements -Since this is a money-paid campaign, the execution must pass Adme's audit. Adme verifies that the content meets the campaign's requirements.",
                        product1: "As the brand representative, you are the one who audits the post content by entering the code in the search bar or scanning the QR code. This allows you to verify that the execution meets the criteria before granting the reward.",
                        product2: "In this type of campaign, you will be responsible for the audit, verifying that the execution meets your criteria before granting the reward.",
                        spot: "Since this is a Spot campaign, the executions are not subject to an audit but are subject to validation."
                    }
                },
                posts: {
                    title: "Posts list",
                    refresh: "Refresh list",
                    refreshDescription: "If you have audited, refresh to update the statuses.",
                    post: {
                        likesLabel: "Likes",
                        commentsLabel: "Comments",
                        shareLabel: "Shared",
                        postsLabel: "Posts",
                        adCode: "Advertisement code",
                        adStatusPart1: "State: ",
                        adStatusPart2: " audit by Adme.",
                        auditAd: "Audit advertisement",
                        pending: 'Pending',
                        rejectedAd: 'Rejected',
                        approvedAd: 'Approved',
                        seeOnSocialSection: {
                            title: "See this post on Socials"
                        },
                        connectOnSocialSection: {
                            title: "Connect [REPLACE_ME] on Socials"
                        },
                        checkPostOptionLabel: "Posts",
                        checkAccountOptionLabel: "Profiles"
                    }
                }

            },
            buttons: {
                goToCampaign: "More details",
                goToFacebook: "See on Facebook",
                engagment: 'Amount of engagement',
                state: 'State: ',
                creation: 'Creation: '
            },
            searcher: {
                button: "Search for an advertisement to audit",
                title: "Search for an advertisement to audit",
                label: "Search: The code is 8 characters long",
                search: "Search",
                searching: "Searching...",
                auditLabel: "This ad is paid with money, therefore it is audited exclusively by Adme",
                auditButton: "Audit Advertisement",
                goToAd: "See advertisement",
                nonExistentAd: "The ad does not exist, or it does not belong to your business."
            }
        },
        investors: {
            hero: {
                title: "Adme, the new concept in social media",
                subtitle: "The first social media that understands that the money from advertising companies should go to social network users, who through their daily posts influence their friends and followers",
                demoURL: "https://www.youtube.com/watch?v=GfTEj6NVdnY"
            },
            promo: {
                title: "Why invest in Adme?",
                subtitle: "If Web1 is about information, Web2 is about content creation and social media. With Web2, running from around 2005 to the present day, the users became active creators and the web went from being a reading platform to a publishing platform. But Web2 has a dark side: the main platforms vaccinated up to the entire economy. In Web2, the user-created the value that the platform enjoyed.",
                subtitle2: "Adme complies with the web3 concept where content creators demand payment of the benefits generated by the influence they achieve on social networks with their posts.",
                reason1Title: "On top of Socials",
                reason1Subtitle: " Adme does not compete with existing social networks, but empowers its users, so that they can finally monetize all the content they have been creating and uploading forever.",
                reason2Title: "Everyone is influencer",
                reason2Subtitle: "Adme believes that one 👍 is one influence generated, so why don't to encourage everyone to sponsor the posts with related Ad Campaigns and therefore to pay the content creator for that?",
                reason3Title: "Blockchain based",
                reason3Subtitle: "Thinking of wallets for Brands and users, it is easy to imagine Adme as a fintech platform as well. Okay, yes! we are building it based on blockchain technology"
            },
            access: {
                title: "Do you want to know more?",
                subtitle: "Potential investiors can request and token to access to the following information:",
            },
            faq: {
                title: "Frequently Asked Questions",
                subtitle1: "All you need yo know about the problems that we try to solve, how are we achieving this, and other information that any investor would like to know before contacting us.",
                subtitle2: '',
                item3Question: "How Adme will make money",
                item3Answer: `Adme is an option for Brands to encourage people, with Ad campaigns, to create posts with related content, and even sponsor the spontaneous photos, that they are posting every day. With Adme, brands will continue having a presence on the same famous social networks but this time by sponsoring content created by the users.
                Adme is changing the current paradigm as follows:
                 - All social network users will be, for the first time, paid for just posting.
                 - Social networks users will be able to post on many social networks at once from one single mobile app.
                 - For the first time, the spontaneous photos posts will be sponsorable.
                 - Brands will be able to launch Ad Campaigns on many social networks at once from one single platform.
                 - Adme monetization: The Ad Campaigns money will be distributed as follows: 
                         - Social media users: 75%
                         - Adme: 25%
                         - Social network platforms: 0%
                `,
                item1Question: "What problem or use case does your company address, and how do your potential target customers get by today in the absence of your product/service?",
                item1Answer: `The problem:
                On one hand, Brands need to advertise genuine content created by people but:
                 a - Social networks only distribute the content created by brands
                 b - Hiring professional influencers to request them to create content is not automated
                 c - People are posting a lot of spontaneous photos with brands, products, and places that can be sponsorable but there is not a mechanism to do that.
                And, on the other hand, 
                 d - social networks users, are posting a lot of content with brands, products, and places, generating influence to their friends and followers, but no one is paying them for that
                Solution
                 - Adme lets brands sponsor content created by people (based on a brief or just spontaneous) in addition to letting people post on their social networks walls content created by brands as well.
                 - All social network users are considered influencers. And for the first time, their spontaneous photo will be paid.
                
                Without Adme:
                 a - Brands' content is delivered by the platforms only. It is not possible to ask people to post them on their walls.
                 b - Not automated. Brands contact influencers or their agent directly. Prices are not standardized.
                c - Not possible
                d - Social networks users continue posting branded photos making brands enjoy the benefits of their influence without rewarding content owners for that`,
                item2Question: "What makes your company stand out amongst that competition?",
                item2Answer: `If Web1 is about information, Web2 is about content creation and social media. With Web2, running from around 2005 to the present day, users became active creators and the web went from being a reading platform to a publishing platform. Bu Web2 had a dark side: the main platforms vaccinated up to the entire economy. In Web2, the user-created the value that the platform enjoyed.
                Adme complies with the web3 concept where content creators demand payment of the benefits generated by the influence they achieve on social networks with said content.`,
                item4Question: "How far along is Adme?",
                item4Answer: `We have version 1 of both applications.
                We launched in March 2022 the first Ad campaign that involved one brand and twenty social media users.
                The plan is to continue bringing social networks users at the same time we launch more and more Ad Campaigns from existing and new Brands.`,
                item5Question: "How long have each of you been working on this? How much of that has been full-time?",
                item5Answer: `We started talking about the concept in June 2018, and in September of the same year, we decided to quit our jobs, live off our savings and family loans, to work full-time building an MVP, with the goal of traveling to San Francisco and probe the concept there. After 6 months of working many hours a day, and after finishing the MVP, we traveled to San Francisco where we stayed for 1 month (May / June 2019). A period in which we pitched 3 times in pitching events. We met a lot of people and after sharing our idea through the use of the app that we had on our cell phones, we came back happy from all the positive feedback we received.
                We came back with no savings and debts, so we had to get a job while we continued working on the development of the platform with the aim of transforming the MVP into version 1.
                In February 2020, we were able to hire our first and only paid Full Stack developer. I say 'paid' because we have Fernando Messala, our Marketing specialist who, after hiring him for a particular need at the end of 2018, stayed with the team forever, making his contributions without receiving financial compensation in return, hoping that in some time Adme raises funds and can hire him full time.
                Something similar happened with Guillermina, girlfriend of Gaston, Javier, and Alexander (friends for many years) whom we trained as QA during the pandemic with the aim of helping them get into the software market and get a job. The 3 achieved the objective, and since then they have been working for large companies such as IBM, Globant while continuing to test Adme without receiving any salary.
                In December 2021 we finished version 1, and in February 2022 we began the path of launching Adme on our own with the strategy of going from less to more at the same time that we resume the path of seeking investments.`,
                item6Question: "Are people using Adme apps?",
                item6Answer: "Yes",
                item7Question: "How many active users or customers do you have?",
                item7Answer: `We launched the first Ad Campaign in Feb/March of this yes after getting the first Brand aboard and installing the Adme mobile app on 21 social media users.
                As the first objective is to solve the problem of the chicken and the egg, the first campaigns are not designed for Adme to monetize, but to increase the volume of brands and influencers.
                The results of the Ad campaign can be seen in the private section that we delivered to the brans after finishing the campaign:
                https://adme.com.ar/#/companies/622cd9a8f6bde20038b43316`,
                item8Question: "Who writes code, or does other technical work on your product? Was any of it done by a non-founder?",
                item8Answer: "Gaston and Mario wrote the code, in addition to Julio, our only one employee Full Stack Dev.",
                item9Question: "How long have the founders known one another and how did you meet?",
                item9Answer: "We are brothers",
            },
            privateDocuments: {
                title: "Private Documents for Investors",
                subtitle: "All the information necessary to confirm that Adme is an exceptional investment opportunity",
                pitchDeck: {
                    title: "Pitch Deck",
                    subtitle: "Access to the Deck that we use to Pitch in San Francisco.",
                    externalURL: "https://docs.google.com/presentation/d/1WtO1UJYFNT1lmwCyi8nXFIB27XCoA8fJ/edit?usp=sharing&ouid=112934507687098617406&rtpof=true&sd=true",
                    externalURLLabel: "Download now"
                },
                demo: {
                    title: "Full Demo",
                    subtitle: "8 minutes demo to show how a Brand launches an ad campaing and a social media user makes money by sponsoring a related facebook post by using adme mobile app",
                    externalURL: "https://www.youtube.com/watch?v=GfTEj6NVdnY",
                    externalURLLabel: "here"
                },
                crunchbase: {
                    title: "crunchbase.com Profile",
                    subtitle: "Visit our profile in crunchbase.com",
                    externalURL: "https://www.crunchbase.com/organization/adme-633a",
                    externalURLLabel: "here"
                },
                gust: {
                    title: "gust.com Profile",
                    subtitle: "Visit our profile in crunchbase.com",
                    externalURL: "https://gust.com/companies/admestartup",
                    externalURLLabel: "here"
                },
                tokenApplyTitle: "Ready to get access?",
                tokenInputPlaceHolder: "Enter token",
                tokenButton: "Unlok Section",
                tokenMessageInProgress: "Unlocking...",
                downloadNowButton: "Download now",
                watchHereButton: "Watch here",
                tokenRequestTitle: "Request a token",
                tokenRequestFullNamePlaceHolder: "Full Name",
                tokenRequestProfilePlaceHolder: "Investor profile url (linkedin or other)",
                tokenRequestButtonLabel: "Request",
                tokenRequestButtonInProgressLabel: "Requesting...",
            }

        },
        web3: {
            hero: {
                title: "The first Web3 Decentralized Social Network",
                subtitle: "Adme democratizes the profits generated by advertising on social networks",
                demoURL: "https://www.youtube.com/watch?v=GfTEj6NVdnY"
            },
            promo: {
                title: "Democratized, decentralized, and fairer Social Network for everyone",
                subtitle: "Adme allows users to make money just by posting on all other socials (Fb, IG, Tw, and others) from one single app. In addition to that, everyone can collaborate with the decentralized infrastructure by running minion nodes and be rewarded with our native Crypto - $ADME",
                reason1Title: "On top of Socials",
                reason1Subtitle: "On Top of current and future Social Networks",
                reason2Title: "Money for users",
                reason2Subtitle: "Ad Campaign budget distributed to posts owners",
                reason3Title: "Decentralized",
                reason3Subtitle: "Resilient architecture based on Web3 infrastructure",
                reason4Title: "Crypto for runners",
                reason4Subtitle: "They receive our native tokens, $ADME, as rewards"
            }
        },
        deleteMyData: {
            title: "Delete Account Request",
            subtitle: "The account and the associated data will be deleted",
            confirmButton: "Delete",
            placeholder: "Write DELETE here",
            confirmMessage: "The request was successfully sent. Your account and all related data will be delete in 72hs."
        },
        joinUs: {
            heroTitle: "Be Part of the Adme Revolution",
            heroSubtitle: "🚀 Be part of the movement reshaping digital marketing. Connect, create, and grow with us as we take your talent and our community to the next level. Your opportunity starts now! ✨",
            positions: {
                influencer: {
                    title: "Inf #014 We Are Looking for Content Creators for Adme",
                    description: `<p><strong>Ready to make waves in digital marketing?</strong> At <strong>Adme</strong>, we’re on a mission to revolutionize the way brands connect with audiences — and we want YOU to be part of it!</p><p>We’re looking for creative, fresh voices with strong video communication skills to join Jazmín and our community team. Help us tell the world what Adme is, share how it’s evolving, communicate key updates, and inspire both users and brands to join the platform. Whether you’re an experienced UGC creator looking to grow or just starting to build your influence, we have <strong>several open roles</strong> where you can showcase your unique style.</p>
                    <h5>Who should apply?</h5>
                    <ul>
                    <li>🌟 Creators passionate about storytelling and content that truly connects.</li>
                    <li>🚀 Emerging talents eager to grow and make an impact in the influencer world.</li>
                    <li>🎯 Anyone ready to create genuine, engaging posts that resonate with a vibrant, young audience.</li>
                    </ul>
                    <h5>What do we offer? 🎁</h5>
                    <ul>
                        <li>💸 Payment per content piece (reel, story, post, etc.)</li>
                        <li>💰 Bonuses for content that generates new leads.</li>
                        <li>📢 Opportunity to become a recurring Adme creator.</li>
                    </ul>`,
                    hiringProcessTitle: "How to apply?",
                    hiringProcessDetails: `
                                <ul>
                                <li>🎥 Record two videos and upload them to the cloud:
                                    <ul>
                                    <li>🕒 1. Tell us in under one minute why you want to be part of Adme.</li>
                                    <li>🎬 2. Use <a href="https://adme.com.ar/assets/img/videoJazDeEjemplo.mp4" target="_blank" rel="noopener noreferrer">this sample video</a> as inspiration — replicate it or make it your own.</li>
                                    </ul>
                                </li>
                                <li>📧 Send the links along with your social profiles (Instagram, TikTok, Facebook, etc.) to <a href="mailto:gaston@adme.com.ar">gaston@adme.com.ar</a> with the reference “Inf #014” and your name in the subject line.</li>
                                </ul>
                                <p>We’ll review every application and get back to you within a week. If you´re selected, we’ll set up a meeting to dive into your first brief and kickstart this exciting journey.</p>
                                <p><strong>Become part of Adme’s global revolution and let your voice be heard! 🌍🚀</strong></p>
                                
                                `,
                    date: "July 1, 2025",
                    tags: "Content Creator | Influencer",
                    positionsAvailable: "10 open positions"
                },
                brandAmbassador: {
                    title: "Emb #011 Become a Brand Ambassador at Adme and grow this Revolution!",
                    description: `
                        <p>Are you already creating content for brands? Do you work with agencies, or are you part of brand communities that could join Adme? Then this opportunity is for you.</p>
                        <p>At <strong>Adme</strong>, we’re looking for <strong>Brand Ambassadors</strong> with real networks and the passion to connect brands and agencies to our revolutionary platform. Whether you’re an influencer, work with agencies, or even a brand connected to other brands — join us and be part of the community that’s changing the game!</p>
                        <h5>Who are we inviting to join?</h5>
                        <ul>
                            <li>✨ You create content for brands and want to help us bring them to Adme.</li>
                            <li>🤝 You work with agencies that could benefit from being part of our platform.</li>
                            <li>🏢 You’re a brand involved in communities or networks of other brands interested in new opportunities.</li>
                            <li>🌍 You have contacts with the potential to grow this amazing network.</li>
                        </ul>
                        <h5>What do we offer? 🎁</h5>
                        <ul>
                            <li>💸 <strong>15% commission</strong> on the budget of the first 3 campaigns of each brand or agency you bring.</li>
                            <li>💰 <strong>$100.000</strong> for every brand or agency that attends a meeting with us interested in joining Adme.</li>
                            <li>📣 Special mentions on our official Instagram accounts to boost your profile and accelerate your reach.</li>
                            <li>🎉 10 referral credits to kickstart your network growth.</li>
                            <li>🎟️ Priority access to exclusive events and training sessions to boost your growth.</li>
                        </ul>
                        `,
                    hiringProcessTitle: "How to apply?",
                    hiringProcessDetails: `
                        <p>Send an email to <a href="mailto:gaston@adme.com.ar">gaston@adme.com.ar</a> with the reference “Emb #011” and your name in the subject line, with your Instagram, TikTok, Facebook, and any other social profiles you have. Tell us why you believe you’d be a great brand ambassador for Adme.</p>
                        <p>From there, we’ll get in touch to build a personalized strategy and start bringing brands and agencies into this great revolution.</p>
                        <p><strong>Join us and let’s make history together! 💥</strong></p>
                        `,
                    date: "July 1, 2025",
                    tags: "Brand Ambassador | Partnerships",
                    positionsAvailable: "Multiple openings"
                }
            }
        }
    },
    es: {
        general: {
            downloadFrom: "Descargar desde",
            brandsLabel: "Marcas",
            NotFoundTitle: "Lo sentimos, algo salió mal",
            NotFoundSubtitle: "La pagina que esta buscando fue removida ó está temporalmente inaccesible.",
            NotFoundbuttonText: "Homepage",
            NoAccessTitle: "Anuncio inaccesible",
            NoAccessSubtitle: "Parece que este anuncio no pertenece a tu compañía o el anuncio no existe.",
            UnauthorizedTitle: "No autorizado",
            UnauthorizedSubtitle: "No tienes permiso para acceder al módulo de auditoría. Por favor, contacta al administrador de tu cuenta si necesitas acceso."
        },
        login: {
            title: "Ingresa a tu cuenta",
            email: "Correo electrónico",
            password: "Contraseña",
            login: "Ingresa",
            signing: "Ingresando...",
            accountYesOrNot: "¿No tenés una cuenta? ",
            register: "Registrate",
            invalidCredentials: "Credenciales invalidas",
            failed: "Hubo un error en el ingreso",
            loaded: "Cargado",
            loading: "Cargando",
            notAvailable: "Servicio no disponible",
            none: "Ninguno",
            loginSuccessful: "Ingreso satisfactorio. Bienvenido!",
            loginError: "Error al ingresar!",
            saving: 'Guardando...',
            saved: 'Los cambios fueron guardados.',
            editError: 'Se produjo un error al editar tu perfil.'
        },
        signUp: {
            signUp: "registrate",
            email: "Correo electrónico",
            password: "Contraseña",
            specificationPassword: "La contraseña debe contener: entre 6 y 15 caracteres, al menos una letra mayúscula, una  minúscula, un número y un caracter especial.",
            confirmPassword: "Confirmar contraseña",
            loading: "Cargando...",
            uploading: "Subiendo ",
            failed: "Hubo un error en la registración",
            notAvailable: "Servicio no disponible",
            none: "None",
            alreadyHaveAccount: "¿Ya tienes una cuenta? ",
            createYourAccount: "Crea tu cuenta",
            addYourCompany: "Agrega tu compañía",
            existEmail: "El correo ingresado ya existe.",
            existCompanyName: 'El nombre de compañía ya existe.',
            companyName: 'Nombre compañía *',
            cellPhone: 'Celular *',
            uploadLogo: 'Cargar Logo (PNG o JPEG)',
            photoError: 'Cargue un archivo de imagen valido (PNG o JPEG).',
            editPhoto: 'Editar foto',
            deletePhoto: 'Eliminar foto',
            iAgree: 'Acepto los ',
            termsAndConditions: 'Términos y Condiciones',
            shouldAcceptTAndC: 'Debes aceptar Términos y Condiciones',
            createCompany: 'Crear la compañía',
            signUpSuccessful: "Registro satisfactorio. Bienvenido!",
            signUpError: "Error al crear la cuenta",
            specificationCellPhone: "No se permiten espacios ni guiones.",
            createCompanySuccessful: 'Creaste tu compañía, felicitaciones!',
            createCompanyError: 'Error al agregar tu compañía'
        },
        editCompany: {
            saving: 'Guardando...',
            saved: 'Los cambios fueron guardados.',
            editError: 'Se produjo un error al editar tu compañía.',
            editTitle: 'Editar datos de la Compañía',
            title: 'Datos de la Compañía',
            companyName: 'Nombre de compañía',
            cellPhone: 'Celular',
            uploadLogo: 'Cargar Logo (PNG o JPEG)',
            photoError: 'Cargue un archivo de imagen valido (PNG o JPEG).',
            editPhoto: 'Editar foto',
            deletePhoto: 'Eliminar foto',
            uploading: "Subiendo ",
            save: "Guardar",
            cancel: "Cancelar",
            editInformation: "Editar información",
            goToProfilInformation: "Ir a información de perfil",
        },
        editProfile: {
            saving: 'Guardando...',
            saved: 'Los cambios fueron guardados.',
            editError: 'Se produjo un error al editar tu perfil.',
            editTitle: 'Editar información de usuario',
            title: 'Información de usuario',
            firstName: 'Nombre',
            lastName: 'Apellido',
            email: 'Email',
            save: "Guardar",
            cancel: "Cancelar",
            editInformation: "Editar información",
            addCompany: 'Agregar compañía',
            goToCompanyInformation: 'Ir a datos de la Compañía',
            goBackMyPortal: 'Volver al portal de mi negocio',
            myPortal: 'Ir al portal de mi negocio'
        },
        audtiAdvertisemnt: {
            approve: 'Aprobar',
            reject: 'Rechazar',
            pending: 'Anuncio pendiente',
            approvedAd: 'Anuncio aprobado',
            rejectedAd: 'Anuncio rechazado',
            brief: 'Instructivo',
            termsAndConditions: 'Detalles y condiciones de participación',
            validate: 'Validar',
            willBePaidWith: 'El anuncio se pagará con ',
            creation: 'Creación ',
            campaignType: 'Tipo de campaña ',
            creatorUser: 'Usuario creador ',
            showSnackbarApproved: 'Se aprobo satisfactoriamente el anuncio.',
            showSnackbarRejected: 'Se rechazo satisfactoriamente el anuncio.',
            youAreInAudit: 'Estas en el modulo de auditoria',
            areYouSureToReject: '¿Estás seguro de que deseas rechazar este anuncio?'
        },
        download: {
            copiedSuccessful: "Código de referido copiado!",
            title: 'En Adme todos son influencers',
            subtitle: 'Adme es la aplicación que te conecta con campañas publicitarias y te permite ganar recompensas por participar en ellas. Más que una simple app, es tu portal hacia una nueva forma de generar contenido y ser recompensado por ello.',
            downloadTitle: 'Descubrí Adme',
            downloadSubtitle: 'Usá este código de referido para crear tu cuenta:',
            preLunchdownloadSubtitle: 'Aún no hemos lanzado, pero no te preocupes, aquí encontrarás un código de referido disponible apenas anunciemos el lanzamiento.',
            bodyTitle: '¿Cómo empezar?',
            bodySubtitle: 'Sigue estos simples pasos para comenzar a ganar a través de Adme',
            step1Title: 'Descargá la App',
            step1Subtitle: 'Hacé clic en el botón de arriba y empezá a disfrutar de Adme.',
            step2Title: 'Ingresá un código de referido',
            step2Subtitle: 'Podés copiar este código o usar el de un amigo/a que ya la haya descargado.',
            step2SubtitlePreLunch: 'Cuando lancemos, verás un código que vas a poder copiar al instante.',
            step3Title: 'Completa tu perfil',
            step3Subtitle: 'Completá todos los campos para crear tu perfil hasta ver que se habilite el botón a la home. Ahí verás las campañas que se ajusten a tu perfil.',
            step4Title: 'Linkeá tu instagram',
            step4Subtitle: 'De este modo, podrás publicar automáticamente en ella el contenido que desees mediante Adme.',
            step5Title: 'Seleccioná una campaña',
            step5Subtitle: 'Las campañas pueden incluir algunas indicaciones o permitirte crear contenido libremente.',
            step6Title: 'Publicá y recibí tu recompensa',
            step6Subtitle: 'Después de publicar, recibirás tu recompensa. Dependiendo de la campaña, serás recompensado con dinero, productos o descuentos.',
            download: 'Descargar'
        },
        downloadAppRedirector: {
            title: 'Redireccionando al store: ',
            subtitle: 'Gracias por tu interés en Adme 🙌',
        },
        childsafetystandards: {
            title: 'Política de Seguridad Infantil de Adme Corp',
            titleParagraph1: '1. Compromiso Contra la Explotación Sexual Infantil',
            paragraph1: 'En Adme ($) estamos comprometidos a proteger a los menores y prohibimos estrictamente cualquier contenido que promueva o tolere la explotación sexual de menores.',
            titleParagraph2: '2. Contenido y Comportamiento Prohibido',
            paragraph20: '- Cualquier tipo de pornografía infantil o material sexualmente explícito que involucre menores.',
            paragraph21: '- Contenido que promueva, aliente o represente actividades sexuales con menores.',
            paragraph22: '- Interacciones en las que un adulto busque explotar a un menor de cualquier forma.',
            titleParagraph3: '3. Reportes y Mecanismo de Denuncia',
            paragraph3: 'Si encuentras contenido inapropiado o sospechas de comportamientos que pongan en riesgo a un menor, por favor repórtalo inmediatamente a nuestro equipo de seguridad enviando un correo a: info@adme.com.ar',
            titleParagraph4: '4. Investigación y Respuesta',
            paragraph4: 'Nuestro equipo revisará cada reporte y tomará medidas de inmediato. Estas pueden incluir la eliminación de contenido, la suspensión de la cuenta involucrada y, de ser necesario, la notificación a las autoridades competentes.',
            titleParagraph5: '5. Cooperación con Autoridades',
            paragraph5: 'Trabajamos en conjunto con las autoridades legales cuando un reporte involucra explotación sexual de menores. Facilitamos información relevante conforme a la legislación local e internacional.',
            titleParagraph6: '6. Contacto',
            paragraph6: 'Para cualquier duda o denuncia relacionada con la seguridad infantil, por favor contacta a: info@adme.com.ar',
            footer: 'Última actualización: 01/23/2025'
        },
        brands: {
            whatIsAdme: {
                whatIsAdme: '¿Qué es Adme?',
                description: 'Adme es la primera plataforma que conecta tu marca con usuarios de redes sociales, transformando sus posteos en la mejor publicidad para vos: el boca a boca viral.',
                bullet1Title: 'Publicidad auténtica',
                bullet1: 'Transformá a tu clientes en tus mejores embajadores siendo ellos los que te recomienden. Alcanzá nuevas audiencias todos los días con contenido genuino.',
                bullet2Title: 'Control de tu presupuesto',
                bullet2: 'Definís cuánto pagar por cada publicación y también cómo hacerlo: con dinero, productos o descuentos. Elegí el presupuesto o stock total de tu campaña.',
                bullet3Title: 'Métricas transparentes y en tiempo real',
                bullet3: 'Creá campañas en menos de 5 minutos y medí la efectividad de tu presencia online de forma muy sencilla y en tiempo real.',
                brands: 'Marcas',
                downloads: 'Descargas',
                startNow: 'Empezá YA',
                viewConcept: 'Ver concepto'
            },
            howTostart: {
                title: '¿Cómo comenzar?',
                stepsDescriptions: 'Para unir tu marca a Adme y comenzar a revolucionar tus estrategias de marketing de influencia, sólo sigue estos pasos. Es completamente gratuito:',
                questionBeforeToStart: `¿Tenés algunas preguntas antes de comenzar? `,
                promo: 'Si te sumas antes del lanzamiento 0% de comision durante los primeros 6 meses.',
                registerTitle: 'Registrarme',
                registerOKTitle: 'Registrado',
                registerOKSubtitle: '¡Te registraste, felicitaciones!',
                registerOkProfileComplete: 'Complete Profile',
                registerOkProfile: 'View Profile',
                registerSubtitle: 'Sumate en pocos segundos.',
                addCompanyTitle: 'Agregar mi negocio',
                addCompanySubtitle: 'Estás a un paso de estar listo.',
                addCompanyOkTitle: 'Empresa agregada',
                addCompanyOkSubtitle: '. ¡Ya sos parte de Adme!',
                addCompanyOkUploadLogo: 'Cargar logo',
                addCompanyOkProfile: 'Ver datos de mi negocio',
                createCampaignTitle: 'Crear mi campaña',
                createCampaignO3Title: 'Ya tenés campañas',
                createCampaignOk1Subtitle: 'Tenés todo listo para contactar a un asesor o tambien podes: ',
                createCampaignOk2Subtitle: 'Contactá a un asesor para modelar tu campaña o también podés',
                createCampaignOk3Subtitle: '¿Querés crear otra campaña?',
                promoPart2: ' comisión del 0% ',
                promoPart3: 'durante los primeros 6 meses.',
                promoOkPart1: '¡Disfruta de ',
                promoOkPart2: ' 0% de comisión ',
                promoOkPart3: 'en tu cuenta durante los próximos 6 meses, ya activado para tu negocio!',
                goToMyCampaigns: 'Ir a mis campañas',
                preDesign: 'Pre-diseñá tu futura campaña',
                chatWhitUs: 'Contactá un asesor',
                planEnterprise: 'Plan empresarial contactanos',
                img: 'assets/img/gratis3meses.png'
            },
            howToWork: {
                Title: '¿Cómo funciona?',
                subtitle: 'Adme te conecta con personas que pueden promocionar genuinamente tus productos y servicios a través de sus redes sociales.',
                step1Title: 'Lanzamiento de campaña',
                step1Subtitle: 'Inicia una campaña en Adme, definiendo tus objetivos y el tipo de contenido que deseas.',
                step2Title: 'Usuarios crean contenido',
                step2Subtitle: 'Los usuarios de Adme crean y comparten contenido alineado con tu campaña, que llega a sus redes sociales personales.',
                step3Title: 'Validación y compensación',
                step3Subtitle: 'Cada publicación es auditada para garantizar su calidad y relevancia, tras lo cual el usuario recibe su recompensa.',
            },
            plansAndPrices: {
                title: 'Planes y precios',
                subtitle: 'Flexibilidad y exclusividad',
                paragraph1: 'En Adme, entendemos que cada marca es única, por eso te ofrecemos libertad total para elegir cómo recompensar a los influencers. ¿Preferís pagar en efectivo,con productos, descuentos o experiencias únicas? La decisión es tuya.',
                paragraph21: 'Al unirte a Adme, las campañas en las que decidas recompensar con dinero serán siempre gratuitas: ',
                paragraph22: 'SIN COSTO DE SERVICIO POR SIEMPRE. ',
                paragraph23: 'Vos definís el presupuesto de tu campaña una sola vez, y Adme se encargará de realizar los pagos a quienes ejecuten tu campaña.',
                paragraph3: 'Las campañas en las que decidas recompensar con un producto/descuento, tampoco tendrán costo de servicio durante los primeros 3 meses tras nuestro lanzamiento. Pasado este período, el costo de servicio será un porcentaje del valor del producto que estés otorgando por cada ejecución.',
                paragraph4: 'Unite ahora y sé parte de una nueva era del marketing digital, donde tu inversión tiene un impacto real y directo.',
            },
            valueProposition: {
                title: 'Nuestra propuesta de valor',
                subtitle: 'Para las marcas, Adme representa una oportunidad de acceder a contenido genuino y diverso, ampliando su alcance e impacto en las redes sociales. A través de nuestra plataforma, las marcas pueden',
                step1Title: 'Lanzar campañas publicitarias',
                step1Subtitle: 'Tus campañas serán diseñadas una sola vez, de forma rápida y asistida.',
                step2Title: 'Ser publicitadas en las redes con contenido auténtico',
                step2Subtitle: 'Tu marca obtendrá contenido original, generado y compartido en sus redes por quienes utilizan tus productos.',
                step3Title: 'Alcanzar a quienes aún no consumen tu marca',
                step3Subtitle: 'Todo usuario que tenga la app de Adme descargada descubrirá tu marca, porque verá tu campaña lista para ejecutar.',
                step4Title: 'Conectar con una amplia red de influencers y usuarios',
                step4Subtitle: 'En Adme, todos pueden ser influencers, desde aquellos que ya monetizan su contenido hasta quienes aún no lo han hecho.',
                step5Title: 'Monitorear tus campañas en tiempo real',
                step5Subtitle: 'Con Adme, tendrás acceso completo a toda la información sobre tus campañas.',
                step6Title: 'Controlar la manera de recompensar a los influencers',
                step6Subtitle: 'Decidí qué y cuánto querés ofrecer por cada contenido creado por tus influencers, ya sea dinero, productos o descuentos.',
            }
        },
        header: {
            menu: {
                about: 'Nosotros',
                process: '¿Cómo?',
                features: 'Funcionalidades',
                passiveIncomes: "Ingresos pasivos",
                brands: 'Marcas',
                agencies: 'Agencias',
                investors: 'Inversores',
                campaigns: 'Campañas',
                companies: 'Compañías',
                web3: 'Web3',
                logout: 'Cerrar sesión',
                signUp: 'Registrarse',
                addCompany: 'Agregar empresa',
                profile: 'Perfil',
                login: 'Iniciar sesión',
                registerMyBusiness: "Registrar mi negocio",
                myPortal: "Portal de mi negocio",
                myPortalHome: "Principal"
            },
        },
        hero: {
            title: "Adme transforma tus posteos en ingresos",
            subtitle: "En Adme sos un Influencer. Usá la app para postear en Instagram y recibí tu pago cada vez que lo hagas.",
            videoUrl: "https://www.youtube.com/watch?v=ZpkI--1X8UI",
        },
        about: {
            title: '¿Por qué Adme es diferente?',
            subtitle: 'Adme te reconoce como el principal protagonista en el mundo de las redes sociales. No importa cuántos amigos y/o seguidores tengas en tus redes sociales: Adme te considera un Influencer, y te paga por ello.',
            reason1Title: 'Tu foto, tu plata',
            reason1Subtitle: "Si sos quien crea las fotos y paga por los productos y servicios que aparecen en ellas, ¿por qué no te pagan por compartirlas?, ¡Adme lo hace posible!",
            reason2Title: 'Posteá desde una sola app',
            reason2Subtitle: "A través de la app de Adme podés publicar fotos en tus redes sociales y ganar dinero con ellas si decidís patrocinarlas.",
            reason3Title: 'Ingresos pasivos',
            reason3Subtitle: 'Adme te paga un porcentaje del dinero que continuamente ganan tus referidos y los referidos de tus referidos. De este modo, también ganás dinero de manera pasiva.',
        },
        counters: {
            socialNetworksConnected: "Redes Sociales Integradas",
            betaTesterUsers: "Usuarios usando la app",
            betaTesterBrands: "Marcas publicitando en Adme",
            currencyIntegrated: "Tipos de monedas integradas"

        },
        process: {
            title: "Monetizar con Adme es muy sencillo",
            subtitle: "Adme pone a tu disposición las campañas publicitarias de las marcas que buscan personas como vos para promocionar sus productos y servicios.",
            stepsImage: "assets/img/adme-mobile-process-to-influencers.png",
            step1Title: "Sacate una selfie",
            step1Subtitle: "Tomá la foto como lo harías normalmente.",
            step2Title: "Esponsorizala y compartila",
            step2Subtitle: "Antes de publicarla en tus redes sociales, asociá la foto con una campaña publicitaria de algún producto o servicio que aparezca en ella.",
            step3Title: "Recibí tu recompensa",
            step3Subtitle: "Una vez que tu foto es evaluada y aprobada, recibirás la recompensa.",
        },
        passiveIncomes: {
            title: "Ingresos pasivos",
            subtitle: "Con Adme no solo ganás dinero al compartir tus fotos, sino que también generás ingresos de manera pasiva.",
            method1Title: "El mejor programa de referidos",
            method1Subtitle: "Toda persona que se sume a Adme gracias a tu invitación, o a la invitación de tus invitados, formará parte de tu clan. Lo mejor es que todos ellos (sin importar qué tan profundo estén en tu red de referidos) te harán ganar dinero, ya que Adme te recompensa con un porcetaje de sus ganancias.",
            method2Title: "El éxito de tus posts",
            method2Subtitle: "Después de recibir el pago por compartir una foto, seguirás recibiendo dinero de acuerdo al éxito que tenga entre tus amigos y seguidores. Adme también te paga por cada \"like\", comentario y otras reacciones en tus publicaciones.",
            method3Title: "",
            method3Subtitle: "",
            method4Title: "",
            method4Subtitle: "",
        },
        features: {
            title: "Funcionalidades de Adme",
            subtitle: "Adme es la primera plataforma que cree que todo usuario de redes sociales es un influencer. Es por esta razón que Adme transforma los beneficios que las marcas obtienen por la influencia de tus fotos, en recompensas monetarias para el protagonista de toda esta historia: ¡vos! 🤟",
            feature1Title: "Una sola app para potenciar tu influencia",
            feature1Subtitle: "Con Adme, tus publicaciones llegan a tu red social favorita de forma simple y efectiva. 📱",
            feature2Title: "Fotos esponsorizadas",
            feature2Subtitle: "Si la foto que estás por publicar contiene algún producto, servicio o lugar, entonces podés esponsorizarla con una campaña publicitaria relacionada. 💰💰💰",
            feature3Title: "Fotos a pedido",
            feature3Subtitle: "También podés crear fotos seguiendo las especificaciones de alguna campaña publicitaria que creas apropiada para vos. 💰💰💰",
            feature4Title: "Compartir spots publicitarios",
            feature4Subtitle: "También podés ganar dinero simplemente compartiendo un spot publicitario creado por la marca. 💰💰💰",
            feature5Title: "Más likes, más ganancias",
            feature5Subtitle: "Después de ganar dinero por publicar una foto esponsorizada, seguís sumando ganancias por el éxito de la misma. Adme te paga por cada por cada like, comentario y otra reacción que reciba. 💰💰💰",
            feature6Title: "Ganar dinero desde tu red de referidos",
            feature6Subtitle: "Cada vez que tus referidos o los referidos de tus referidos ganen dinero, vos también ganarás un porcentaje del mismo. 💰💰💰",
        },
        testimonials: {
            title: "Lo que opina la gente sobre esta nueva propuesta",
            subtitle: "El nuevo paradigma propuesto por Adme está focalizado a satisfacer, principalmente, las nacesidades los los usuarios de redes sociales. Esto es lo que opinan sobre esta nueva propuesta!",
            testimonial1Name: "Giselle Yaccuzzy",
            testimonial1Title: "Usuario de Facebook e Instagram",
            testimonial1Testimony: "Es muy emocionante saber que llegó una red social que entiende que al compartir una foto en mis redes sociales habituales, estoy influenciando a mis amigos y seguidores a que consuman los productos y servicios que aparecen en ella 😍",
            testimonial2Name: "María Fernanda Iglesias",
            testimonial2Title: "Actriz. (@marifernandai) • Instagram",
            testimonial2Testimony: "",
            testimonial3Name: "Gonzalo Abadie",
            testimonial3Title: "Actor, (@Gonzactor) • Twitter",
            testimonial3Testimony: "",
            testimonial4Name: "",
            testimonial4Title: "",
            testimonial4Testimony: "",
        },
        faq: {
            title: "Preguntas frecuentes",
            subtitle1: "Sabemos que suena increíble que una red social le pague a sus usuarios, pero es real. ¡Adme lo hace!",
            subtitle2: "Si tenés dudas, estamos para ayudarte. ¡Escribinos!",
            q1Question: "¿Tiene algún costo la aplicación? 🙌",
            q1Answer: "Adme es 100% gratis, porque el único objetivo es que ganes productos o dinero con tu contenido, y el contenido que tus referidos generen.",
            q2Question: "¿Me pagan por usar mi red social habitual? 💵",
            q2Answer: "Sí, al linkear Adme a tu cuenta de Instagram podés publicar fotos como usualmente lo hacés, pero con la oportunidad de recibir dinero por ello. Ya que Adme publica automaticamente tu contenido en tu red social con los @ y # de cada campaña publicitaria.",
            q3Question: "¿Para qué sirve el código de referido? 🏂",
            q3Answer: "Para registrarte en Adme necesitas un código de referido. A su vez, vos como usuario tendrás tu propio código que te permitirá mediante el sistema de referidos, ganar el 5% de las ganancias que tus referidos obtengan por su actividad en la aplicación. Cuando tengas tu código, compartilo con amigos, en reuniones o publicalo en tus redes!.",
            q4Question: "¿Qué tipo de contenido puedo crear? 📸",
            q4Answer: "Como cada publicación es única, en Adme ofrecemos tres tipos de campañas pensadas para distintos momentos y formas de compartir. Podés elegir entre sacarte una foto siguiendo directivas de una campaña o asociar una foto totalmente espontánea a una campaña disponible. También publicar contenido creado por las marcas.",
            q5Question: "¿Importa si mis fotos reciben reacciones? ❤️",
            q5Answer: "Sí! ya que Adme no solo te paga por publicar fotos en tu red social, sino que también te paga por el éxito que éstas tengan entre tus amigos y seguidores. Cada comentario, \"like\" o interacción vale!",
            q6Question: "¿Cómo recibo mis recompensas? 🤝",
            q6Answer: "Podés obtener recompensas en productos o descuentos en tiempo real. O también recompensas en dinero a través de pagos mensuales a la cuenta que hayas configurado en tu perfil de usuario.",
        },
        footer: {
            subscribe: {
                title: "Si tenés una marca, sumate a Adme",
                subtitle: "Y obtené beneficios exclusivos",
                placeholder: "Ingresá tu IG",
            },
            corp: {
                subtitle: "La plataforma de publicidad disruptiva que llegó para cambiar el paradigma de la publicidad en redes sociales."
            },
            products: {
                title: "Productos",
                title2: "Portal Web",
                p1: "Adme Mobile App",
                p2: "Lanzar una campaña",
                p3: "adme.com.ar",
                p4: "Redes sociales"
            },
            company: {
                title: "La empresa",
                section1: "Nosotros",
                section2: "La Comunidad",
                section3: "Invierte en Adme",
                section4: "Trabaja con nosotros"
            },
            support: {
                title: "Soporte",
                s1: "FAQ",
            },
            rights: "Adme, Todos los derechos están reservados",
            contactAgent: 'Contactar un agente'
        },
        commingSoonInvestors: {
            title: "We're Coming Soon",
            subtitle: "El website de Adme para inversores está siendo construido. Pronto tendrás toda la información para invertir en Adme, suscribase para recibir novedades.",
            placeholder: "Ingresá tu email",
        },
        commingSoonBrands: {
            title: "We're Coming Soon",
            subtitle: "El website de Adme para las Marcas y Agencias está siendo construido. Muy pronto tendrás toda la información sobre ésta nueva propuesta de publicidad en Resdes Sociales, suscribase para recibir novedades.",
            placeholder: "Ingresá tu email",
        },
        team: {
            sections: {
                cofounders: {
                    title: "Nuestros fundadores",
                    subtitle: "Diversión, creatividad desde los impedimentos, fallar temprano para llegar al éxito; son algunos de los valores que los hermanos Ruiz Diaz, nuestros fundadores, fomentan y que justifican que Adme sea tan disruptivo para el mercado de la publicidad en redes sociales"
                },
                footer: {
                    theTeamTitle: "Somos un equipo de personas que pensamos diferente",
                    theTeamSubtitle: "Conocé a las mentes creativas detrás de Adme",
                    hereButtonLabel: "aquí"
                }
            },
            gaston: {
                fullName: "Gastón Ruiz Diaz",
                role: "Co-Fundador",
                roleDescription: "Gastón y su hermano, Mario Ruiz Diaz son los fundadores de la nueva generación en redes sociales, Adme",
                techRole: "Full Stack Developer",
                techRoleDescription: "Licenciado en Sistemas con más de 15 años en la industria del desarrollo de software",
                personalityDescription: "",
                phone: "+54 911 4085-1807",
                email: "gaston@adme.com.ar",
                picturePath: "gaston500x500.jpg",
                linkedinURL: "https://www.linkedin.com/in/gaston-ruiz-diaz-157366bb/"
            },
            mario: {
                fullName: "Mario Ruiz Diaz",
                role: "Co-Fundador",
                roleDescription: "Mario y su hermano, Gastón Ruiz Diaz son los fundadores de la nueva generación en redes sociales, Adme",
                techRole: "Hands-on Software Architect",
                techRoleDescription: "Licenciado en Sistemas con más de 18 años en la industria del desarrollo de software",
                personalityDescription: "",
                phone: "+54 911 4085-1807",
                email: "mario@adme.com.ar",
                picturePath: "Mario.jpg",
                linkedinURL: "https://www.linkedin.com/in/marioruizdiaz/"
            },
            yulian: {
                fullName: "Julio Aranda",
                role: "Ingeniero de Software",
                roleDescription: "Yulian es uno de los responsables que está creando ésta nueva generación de redes sociales, Adme",
                personalityDescription: "",
                phone: "+54 911 5139-4412",
                email: "julio.aranda@adme.com.ar",
                picturePath: "yulian500x500.jpeg",
                linkedinURL: "https://www.linkedin.com/in/julioarandadev/"
            },
            alex: {
                fullName: "Alexander Paez Yepez",
                role: "Quality Assurance",
                roleDescription: "Alexander es uno de los responsables que está creando ésta nueva generación de redes sociales, Adme",
                personalityDescription: "",
                phone: "+54 911 4085-1807",
                email: "alexander.paez@adme.com.ar",
                picturePath: "alex.jpg",
                linkedinURL: "https://www.linkedin.com/in/alexander-paez/"
            },
            guille: {
                fullName: "Guillermina Diaz",
                role: "Quality Assurance",
                roleDescription: "Guille es uno de los responsables que está creando ésta nueva generación de redes sociales, Adme",
                personalityDescription: "",
                phone: "+54 911 4085-1807",
                email: "guillermina.diaz@adme.com.ar",
                picturePath: "guille.jpg",
                linkedinURL: "https://www.linkedin.com/in/guillermina-d%C3%ADaz-57a11337/"
            },
            javy: {
                fullName: "Javier Andriani",
                role: "Quality Assurance",
                roleDescription: "Javy es uno de los responsables que está creando ésta nueva generación de redes sociales, Adme",
                personalityDescription: "",
                phone: "+54 911 4085-1807",
                email: "javier.andriani@adme.com.ar",
                picturePath: "javy.jpg",
                linkedinURL: "https://www.linkedin.com/in/javierandrianiqcanalyst/"
            },
            fer: {
                fullName: "Fernando Messala",
                role: "Marketing Specialist",
                roleDescription: "Fer es uno de los responsables que está creando ésta nueva generación de redes sociales, Adme",
                personalityDescription: "",
                phone: "+54 911 4085-1807",
                email: "fernando.messala@adme.com.ar",
                picturePath: "fer.jpg",
                linkedinURL: "https://www.linkedin.com/in/fernando-messala/"
            },
            nico: {
                fullName: "Nicolas Carosio",
                role: "IT Specialist",
                roleDescription: "Nico es uno de los responsables que está creando ésta nueva generación de redes sociales, Adme",
                personalityDescription: "",
                phone: "+54 911 4085-1807",
                email: "nicolas.carosio@adme.com.ar",
                picturePath: "nico.jpg",
                linkedinURL: "https://www.linkedin.com/in/nicolas-carosio-13096615/"
            },
            jazmin: {
                fullName: "Jazmin Diaz",
                role: "Head of Image and Digital Strategy",
                roleDescription: "Encargada de la imagen de Adme y responsable de diseñar e implementar la estrategia en redes sociales para conectar con el usuario final. Desarrolla campañas creativas que reflejan la identidad de la marca, impulsando su crecimiento y presencia digital. Colabora en la creación de contenidos relevantes y atractivos, asegurando que los mensajes clave lleguen de manera efectiva a la audiencia objetivo. Además, gestiona y optimiza la interacción con los usuarios en diversas plataformas digitales, con un enfoque en mejorar la experiencia del cliente y fomentar la fidelización.",
                personalityDescription: "",
                phone: "",
                email: "jazmin.diaz@adme.com.ar",
                picturePath: "jazmin.jpg",
                linkedinURL: "https://www.linkedin.com"
            },
            luis: {
                fullName: "Luis, Da Silva",
                role: "Quality Assurance",
                roleDescription: "Luis es uno de los responsables que está creando ésta nueva generación de redes sociales, Adme.",
                personalityDescription: "",
                phone: "",
                email: "luis@adme.com.ar",
                picturePath: "luis.jpg",
                linkedinURL: "https://www.linkedin.com/in/qaluiscarlosdasilva1/"
            },
        },
        guides: {
            title: "Todo lo que necesitas para comenzar a monetizar con Adme",
            breadcrumbTitle: "Guias",
            grid: {

            },
            ios: {
                install: {
                    title: "Guía de instalación para iOS",
                    subTitle: "Guía paso a paso para tener funcionando Adme en tu iPhone",
                    smallCard: {
                        title: "Instalación de Adme en iPhone",
                        subtitle: "Guía paso a paso para poder instalar la app en tu iPhone",

                    },
                    step1: {
                        title: "1. Descarga TestFlight",
                        subtitle: "",
                        subSteps: {
                            a: "Ingresa a ",
                            b: "Instala la aplicación",
                            c: "Aprueba los permisos necesarios.",
                            d: "",
                            e: ""
                        }
                    },
                    step2: {
                        title: "2. Unete a Beta Testers de Adme",
                        subtitle: "Luego de instalar testFlight...",
                        subSteps: {
                            a: "Sumate como Beta!",
                            b: "",
                            c: "",
                            d: ""
                        }
                    },
                    step3: {
                        title: "3. Instala Adme. ",
                        subtitle: "",
                        subSteps: {
                            a: "Presiona instalar...",
                            b: "Luego presiona abrir.",
                            c: "Bienvenido a Adme!",
                            d: "",
                            e: ""
                        }
                    },
                    step4: {
                        title: "4. Bienvenido a Adme !",
                        subtitle: "Luego de la instalación has lo siguiente:",
                        subSteps: {
                            a: "Crea una cuenta",
                            b: "Completa tus preferencias y linkea tus redes sociales."
                        }
                    },
                    step5: {
                        title: "5. Sign Up",
                        subtitle: "Como es la primera vez que vas a usar Adme, es necesario crear una cuenta.",
                        subSteps: {
                            a: "Tocá el botón \"Sign Up\".",
                            b: "Ingresá el siguiente código \"9CD4CD95\" y toca el botón \"next\".",
                            c: "Define un e-mail.",
                            d: "Ingresa una password para Adme. (Min. 6 caracteres. Debe contener al menos una letra mayúscula, una minúscula y hasta dos números consecutivos)"
                        }
                    },
                    step6: {
                        title: "6. Linkeo de tu cuenta de Facebook",
                        subtitle: "Con el objetivo de permitirle a Adme que cree contenido en tu muro de Facebook, es necesario que linkees tu cuenta.",
                        subSteps: {
                            a: "Toca el botón de Facebook",
                            b: "Ingresa tu mail y password que usar para ingresar a Facebook",
                            c: "Si la aplicación te pide alguna validación realizala hasta completar el linkeo",
                            d: ""
                        }
                    },
                    step7: {
                        title: "7. Información Básica",
                        subtitle: "Con el objetivo de hacerte llegar campañas publicitarias específicas a tus intereses, es necesario que completes la siguiente información",
                        subSteps: {
                            a: "Completar los campos: Categories of interest, Gender, Country, State and City.",
                            b: "Deslizate al final y presiona el botón 'GUARDAR'",
                            c: "Finalmente, tocá el botón 🏠 para ir a la pantalla principal de Adme.",
                            d: ""
                        }
                    },
                    step8: {
                        title: "8. Felicitaciones!",
                        subtitle: "Ya estás listo para comenzar a ganar dinero con Adme!",
                        subSteps: {
                            a: "",
                            b: "",
                            c: "",
                            d: ""
                        }
                    }

                }
            },
            android: {
                install: {
                    title: "Guía de instalación para Android",
                    subTitle: "Guía paso a paso para tener funcionando Adme en tu Móvil Android",
                    smallCard: {
                        title: "Instalación de Adme en Android",
                        subtitle: "Guía paso a paso para poder instalar la app en tu Android",

                    },
                    step1: {
                        title: "1. Descargar la app desde el Play Store",
                        subtitle: "Adme, aún  no está incluida en la búsqueda del Store",
                        subSteps: {
                            a: "Usar el siguiente enlace  ",
                            b: "Haz click en el botón 'Become a tester'",
                            c: "Bienvenido al programa de testeo!",
                            d: ""
                        }
                    },
                    step2: {
                        title: "2. Instalar la app de Adme",
                        subtitle: "* Presiona el enlace \" download it on Google Play\".",
                        subSteps: {
                            a: "Luego presiona instalar...",
                            b: "Finalmente presiona el botón 'Abrir'."
                        }
                    },
                    step3: {
                        title: "3. Sign Up",
                        subtitle: "Como es la primera vez que vas a usar Adme, es necesario crear una cuenta.",
                        subSteps: {
                            a: "Tocá el botón \"Sign Up\".",
                            b: "Ingresá el siguiente código \"9CD4CD95\" y tocá el botón \"next\".",
                            c: "Define un e-mail.",
                            d: "Ingresa una password para Adme. (Min. 6 caracteres. Debe contener al menos una letra mayúscula, una minúscula y hasta dos números consecutivos)"
                        }
                    },
                    step4: {
                        title: "4. Linkeo de tu cuenta de Facebook",
                        subtitle: "Con el objetivo de permitirle a Adme que cree contenido en tu muro de Facebook, es necesario que linkees tu cuenta.",
                        subSteps: {
                            a: "Toca el botón de Facebook.",
                            b: "Ingresa tu mail y password que usar para ingresar a Facebook.",
                            c: "Si la aplicación te pide alguna validación realizala hasta completar el linkeo",
                            d: ""
                        }
                    },
                    step5: {
                        title: "5. Información Básica",
                        subtitle: "Con el objetivo de hacerte llegar campañas publicitarias específicas a tus intereses, es necesario que completes la siguiente información",
                        subSteps: {
                            a: "Completar los campos: Categories of interest, Gender, Country, State and City.",
                            b: "Deslizate al final y presiona el botón 'GUARDAR'",
                            c: "Finalmente, tocá el botón 🏠 para ir a la pantalla principal de Adme.",
                            d: ""
                        }
                    },
                    step6: {
                        title: "6. Felicitaciones!",
                        subtitle: "Ya estás listo para comenzar a usar Adme!",
                        subSteps: {
                            a: "",
                            b: "",
                            c: "",
                            d: ""
                        }
                    }

                }
            },
            buttons: {
                readMore: "Ir a la guía",
                next: "Siguiente",
                downloadNow: "Descargar"
            }

        },
        results: {
            companies: {
                hero: {
                    title: "Campañas agrupadas por Marcas",
                    subtitle: "Empresas usando Adme"
                },
                items: {
                    kpis: {
                        onGoingTitle: "campañas activas"
                    },
                    buttons: {
                        goToCompaigns: "Ver Campañas"
                    }
                }

            },
            company: {
                hero: {
                    subtitle: "Visualización de actividades y resultados de campañas en Adme"
                }
            },
            campaign: {
                hero: {
                    title: "Resultados de la campaña",
                    state: "Estado: ",
                    draft: "Borrador",
                    onGoing: "Activas",
                    stopped: "Pausadas",
                    finished: "Finalizada",
                    typeOfCampaign: "Tipo de campaña: ",
                    spot: "Spot: En esta campaña proporcionaste el contenido (como fotos o videos) de tu Marca, y los usuarios sólo deben compartirlo. Este contenido se publica automáticamente en sus perfiles de redes sociales a través de Adme.",
                    sponsorship: "Sponsorship (Patrocinio): En estas campañas, tu marca auspicia publicaciones espontáneas de usuarios en redes sociales, aprovechando el contenido orgánico generado por ellos que se alinea con tu marca y los objetivos de la campaña.",
                    advertising: "Advertising (Publicidad): Al momento de crear esta campaña estableciste indicaciones claras sobre el contenido que deben crear los influencers. Los usuarios deben seguir las instrucciones para asegurar que el contenido compartido refleje los mensajes y la identidad visual que busca la campaña​.",
                    youArePayingPart1: "Estás recompensando cada foto con ",
                    youArePayingPart21: "dinero: ",
                    youArePayingPart22: ": ",
                    youArePayingWithMoney: "Pagarás con dinero a los usuarios que ejecuten tu campaña publicitaria a través de Adme. El pago se realizará después de que Adme audite el contenido de las publicaciones.",
                    youArePayingWitProduct: "Recompensarás a los usuarios con productos, descuentos, promociones u otros incentivos.",
                    youArePayingFooter: "Este enfoque garantiza que los usuarios solo sean recompensados cuando la acción publicitaria se haya ejecutado correctamente y después de la auditoría correspondiente según el tipo de campaña.",
                    advertisingCampaignConditions: {
                        title: "Bases y condiciones",
                        advertising: "Tu campaña es de tipo Advertising, por lo que las condiciones necesarias para su ejecución fueron descritas en el brief. Este documento se completó con los requisitos específicos que aseguran que los anuncios creados por los usuarios se alineen con los objetivos y valores de tu marca. ",
                        sponsorshipTitle: "En las campañas de tipo Sponsorship, aunque se promueven momentos espontáneos compartidos por los usuarios, es fundamental mantener ciertos estándares de calidad para que el contenido refleje adecuadamente a tu marca. Las condiciones clave para la aprobación de estos contenidos incluyen:",
                        sponsorshipItem1: "Claridad y nitidez: Las fotos no deben estar borrosas, movidas ni desenfocadas.",
                        sponsorshipitem2: "Buena iluminación: Las imágenes deben estar bien iluminadas para asegurar que los elementos principales sean claramente visibles.",
                        spot: "El contenido de esta campaña fue proporcionado por tu negocio al momento de su creación. Cuando el usuario ejecuta el anuncio, este contenido se publicará automáticamente en sus redes sociales. Dado que el usuario solo necesita realizar la ejecución de la campaña, no está sujeto a auditoría, ya que la foto cargada por tu marca se publicará de manera automática en sus perfiles. Pero si esta sujeto a validacion."
                    },
                    brief: "Intrucciones (Brief)",
                    money: "Dinero disponible: ",
                    stock: "Stock disponible: ",
                    of: " de ",
                    spend: "Gastaste: ",
                    stockAvailable: "Stock disponible ",
                    audit: {
                        title: "Auditoría / validación",
                        money: "Al ser una campaña que paga con dinero, la ejecución debe pasar la auditoría de Adme, que verifica que el contenido cumpla con los requisitos establecidos en tu campaña.",
                        product1: "Debés validar que efectivamente se haya ejecutado la campaña, ingresando el código en el buscador o scaneando el QR.",
                        product2: "En este tipo de campaña, tú serás responsable de la auditoría, verificando que la ejecución cumple con tus criterios antes de otorgar la recompensa.",
                        spot: "Debés validar que efectivamente se haya ejecutado la campaña, ingresando el código en el buscador o scaneando el QR."
                    }
                },
                posts: {
                    title: "Listado de Posts",
                    refresh: "Actualizar lista",
                    refreshDescription: "Si has auditado, refresca para actualizar los estados.",
                    post: {
                        likesLabel: "Me gusta",
                        commentsLabel: "Comentarios",
                        shareLabel: "Compartido",
                        postsLabel: "Posts",
                        adCode: "Código del anuncio",
                        adStatusPart1: "Estado: ",
                        adStatusPart2: " de auditoria por Adme.",
                        auditAd: "Auditar Anuncio",
                        pending: 'Pendiente',
                        rejectedAd: 'Rechazado',
                        approvedAd: 'Aprobado',
                        seeOnSocialSection: {
                            title: "Ver el post en las redes"
                        },
                        connectOnSocialSection: {
                            title: "Conectar a [REPLACE_ME] en las redes"
                        },
                        checkPostOptionLabel: "Posteos",
                        checkAccountOptionLabel: "Perfiles"
                    }
                }

            },
            buttons: {
                goToCampaign: "Ver detalles",
                goToFacebook: "Ver en Facebook",
                engagment: 'Cantidad de interacciones',
                state: 'Estado: ',
                creation: 'Creación: '
            },
            searcher: {
                button: "Buscar anuncio para auditar",
                title: "Buscar anuncio para auditar",
                label: "Buscar: El código es de 8 caracteres",
                search: "Buscar",
                searching: "Buscando...",
                auditLabel: "Este anuncio se paga con dinero, por tal motivo es auditable sólo por Adme",
                auditButton: "Auditar Anuncio",
                goToAd: "Ver anuncio",
                nonExistentAd: "El anuncio no existe, o no pertenece a tu negocio."
            }
        },
        investors: {
            hero: {
                title: "Adme, un nuevo concepto en redes sociales",
                subtitle: "La primer red social que entiende que el dinero de las campañas publicitarias debe ser para los usuarios de redes sociales, quienes mediantes sus posts diarios influencian a sus amigos y seguidores",
                demoURL: "https://www.youtube.com/watch?v=GfTEj6NVdnY"
            },
            promo: {
                title: "¿Por qué invertir en Adme?",
                subtitle: "Si Web1 se trata de información, Web2 se trata de creación de contenido y redes sociales. Con Web2, funcionando desde alrededor de 2005 hasta la actualidad, los usuarios se convertieron en creadores activos y la web pasó de ser una plataforma de lectura a una plataforma de publicación. Pero Web2 tiene un lado oscuro: las principales plataformas distorcionan a toda la economía. En Web2, el usuario creaba el valor que acaparan las plataformas.",
                subtitle2: "Adme cumple con el concepto web3 donde los creadores de contenido exigen el pago de los beneficios generados por la influencia que logran en las redes sociales con sus publicaciones.",
                reason1Title: "On top of Socials",
                reason1Subtitle: "Adme no compite con las redes sociales existentes, sino que empodera a sus usuarios, para que por fin, puedan monetizar todo el contenido que vienen creando y subiendo desde siempre",
                reason2Title: "Todos somos influencer",
                reason2Subtitle: "Adme cree que un 👍 es una influencia generada, entonces, ¿por qué no animar a todos los usuarios a auspiciar las publicaciones con campañas publicitarias relacionadas, pagando a sus creadores?",
                reason3Title: "Blockchain",
                reason3Subtitle: "Pensando en billeteras para Marcas y usuarios, es fácil imaginar una plataforma fintech. ¡Bueno, sí! lo estamos construyendo sobre la tecnología blockchain"
            },
            access: {
                title: "¿Te gustaría saber mas?",
                subtitle: "Los potenciales inversores pueden solicitar un token para acceder a la siguiente informacion:",
            },
            faq: {
                title: "Preguntas frecuentes",
                subtitle: "Todo lo que necesita saber sobre los problemas que tratamos de resolver, cómo lo estamos logrando y otra información que a cualquier inversor le gustaría saber antes de contactar con nosotros.",
                item3Question: "How Adme will make money",
                item3Answer: `Adme is an option for Brands to encourage people, with Ad campaigns, to create posts with related content, and even sponsor the spontaneous photos, that they are posting every day. With Adme, brands will continue having a presence on the same famous social networks but this time by sponsoring content created by the users.
                Adme is changing the current paradigm as follows:
                 - All social network users will be, for the first time, paid for just posting.
                 - Social networks users will be able to post on many social networks at once from one single mobile app.
                 - For the first time, the spontaneous photos posts will be sponsorable.
                 - Brands will be able to launch Ad Campaigns on many social networks at once from one single platform.
                 - Adme monetization: The Ad Campaigns money will be distributed as follows: 
                         - Social media users: 75%
                         - Adme: 25%
                         - Social network platforms: 0%
                `,
                item1Question: "What problem or use case does your company address, and how do your potential target customers get by today in the absence of your product/service?",
                item1Answer: `The problem:
                On one hand, Brands need to advertise genuine content created by people but:
                 a - Social networks only distribute the content created by brands
                 b - Hiring professional influencers to request them to create content is not automated
                 c - People are posting a lot of spontaneous photos with brands, products, and places that can be sponsorable but there is not a mechanism to do that.
                And, on the other hand, 
                 d - social networks users, are posting a lot of content with brands, products, and places, generating influence to their friends and followers, but no one is paying them for that
                Solution
                 - Adme lets brands sponsor content created by people (based on a brief or just spontaneous) in addition to letting people post on their social networks walls content created by brands as well.
                 - All social network users are considered influencers. And for the first time, their spontaneous photo will be paid.
                
                Without Adme:
                 a - Brands' content is delivered by the platforms only. It is not possible to ask people to post them on their walls.
                 b - Not automated. Brands contact influencers or their agent directly. Prices are not standardized.
                c - Not possible
                d - Social networks users continue posting branded photos making brands enjoy the benefits of their influence without rewarding content owners for that`,
                item2Question: "What makes your company stand out amongst that competition?",
                item2Answer: `If Web1 is about information, Web2 is about content creation and social media. With Web2, running from around 2005 to the present day, users became active creators and the web went from being a reading platform to a publishing platform. Bu Web2 had a dark side: the main platforms vaccinated up to the entire economy. In Web2, the user-created the value that the platform enjoyed.
                Adme complies with the web3 concept where content creators demand payment of the benefits generated by the influence they achieve on social networks with said content.`,
                item4Question: "How far along is Adme?",
                item4Answer: `We have version 1 of both applications.
                We launched in March 2022 the first Ad campaign that involved one brand and twenty social media users.
                The plan is to continue bringing social networks users at the same time we launch more and more Ad Campaigns from existing and new Brands.`,
                item5Question: "How long have each of you been working on this? How much of that has been full-time?",
                item5Answer: `We started talking about the concept in June 2018, and in September of the same year, we decided to quit our jobs, live off our savings and family loans, to work full-time building an MVP, with the goal of traveling to San Francisco and probe the concept there. After 6 months of working many hours a day, and after finishing the MVP, we traveled to San Francisco where we stayed for 1 month (May / June 2019). A period in which we pitched 3 times in pitching events. We met a lot of people and after sharing our idea through the use of the app that we had on our cell phones, we came back happy from all the positive feedback we received.
                We came back with no savings and debts, so we had to get a job while we continued working on the development of the platform with the aim of transforming the MVP into version 1.
                In February 2020, we were able to hire our first and only paid Full Stack developer. I say 'paid' because we have Fernando Messala, our Marketing specialist who, after hiring him for a particular need at the end of 2018, stayed with the team forever, making his contributions without receiving financial compensation in return, hoping that in some time Adme raises funds and can hire him full time.
                Something similar happened with Guillermina, girlfriend of Gaston, Javier, and Alexander (friends for many years) whom we trained as QA during the pandemic with the aim of helping them get into the software market and get a job. The 3 achieved the objective, and since then they have been working for large companies such as IBM, Globant while continuing to test Adme without receiving any salary.
                In December 2021 we finished version 1, and in February 2022 we began the path of launching Adme on our own with the strategy of going from less to more at the same time that we resume the path of seeking investments.`,
                item6Question: "Are people using Adme apps?",
                item6Answer: "Yes",
                item7Question: "How many active users or customers do you have?",
                item7Answer: `We launched the first Ad Campaign in Feb/March of this yes after getting the first Brand aboard and installing the Adme mobile app on 21 social media users.
                As the first objective is to solve the problem of the chicken and the egg, the first campaigns are not designed for Adme to monetize, but to increase the volume of brands and influencers.
                The results of the Ad campaign can be seen in the private section that we delivered to the brans after finishing the campaign:
                https://adme.com.ar/#/companies/622cd9a8f6bde20038b43316`,
                item8Question: "Who writes code, or does other technical work on your product? Was any of it done by a non-founder?",
                item8Answer: "Gaston and Mario wrote the code, in addition to Julio, our only one employee Full Stack Dev.",
                item9Question: "How long have the founders known one another and how did you meet?",
                item9Answer: "We are brothers",
            },
            privateDocuments: {
                title: "Documentos exclusivamente para inversionistas",
                subtitle: "Toda la información necesaria para confirmar que Adme es una oportunidad exepcional de inversión",
                pitchDeck: {
                    title: "Pitch Deck",
                    subtitle: "Acceda al Deck que usamos para pitchear en San Francisco.",
                    externalURL: "https://docs.google.com/presentation/d/1WtO1UJYFNT1lmwCyi8nXFIB27XCoA8fJ/edit?usp=sharing&ouid=112934507687098617406&rtpof=true&sd=true",
                    externalURLLabel: "Descargar"
                },
                demo: {
                    title: "Full Demo",
                    subtitle: "8 minutes demo to show how a Brand launches an Ad Campaing and a social media user makes money by sponsoring a related facebook post by using adme mobile app",
                    externalURL: "https://www.youtube.com/watch?v=GfTEj6NVdnY",
                    externalURLLabel: "aquí"
                },
                crunchbase: {
                    title: "Perfile en crunchbase.com",
                    subtitle: "Visite nuestro perful en crunchbase.com",
                    externalURL: "https://www.crunchbase.com/organization/adme-633a",
                    externalURLLabel: "aquí"
                },
                gust: {
                    title: "Perfil en gust.com",
                    subtitle: "Visite nuestro perfil en gust.com",
                    externalURL: "https://gust.com/companies/admestartup",
                    externalURLLabel: "aquí"
                },
                tokenApplyTitle: "¿Listo para acceder?",
                tokenInputPlaceHolder: "Ingrese el token",
                tokenButton: "Desbloquear",
                tokenMessageInProgress: "Desbloqueando...",
                downloadNowButton: "Descargar",
                watchHereButton: "Ver aqui",
                tokenRequestTitle: "Solicitar un token",
                tokenRequestFullNamePlaceHolder: "Nombre completo",
                tokenRequestProfilePlaceHolder: "Url del perfil como inversor (linkedin u otro)",
                tokenRequestButtonLabel: "Solicitar",
                tokenRequestButtonInProgressLabel: "Solicitando...",
            }
        },
        web3: {
            hero: {
                title: "La primer Red Social Web3 Descentralizada",
                subtitle: "Adme democratiza las ganancias generadas por las publicidades en redes sociales",
                demoURL: "https://www.youtube.com/watch?v=GfTEj6NVdnY"
            },
            promo: {
                title: "Red social democratizada, descentralizada y más justa para todos",
                subtitle: "Adme permite a los usuarios ganar dinero simplemente publicando en todas las demás redes sociales (Fb, IG, Tw y otras) desde una sola aplicación. Además de eso, todos pueden colaborar con la infraestructura descentralizada mediante la ejecución de nodos minion y ser recompensados con nuestro Crypto nativo - $ADME.",
                reason1Title: "Todas las redes sociales integradas",
                reason1Subtitle: "Integra todas las redes sociales existentes y que aun no existen",
                reason2Title: "Dinero para los usuarios",
                reason2Subtitle: "Dinero de campaña publicitaria distribuido creadores de contenido",
                reason3Title: "Infrastructura Descentralizada",
                reason3Subtitle: "Arquitectura resistente basada en infraestructura Web3",
                reason4Title: "Crypto para los runners",
                reason4Subtitle: "Reciben nuestros tokens nativos, $ADME, como recompensas"
            },
        },
        deleteMyData: {
            title: "Solicitud de eliminacion de la cuenta de Adme",
            subtitle: "Todos los datos relacionados serán eliminados",
            confirmButton: "Eliminar",
            placeholder: "Escriba ELIMINAR aqui",
            confirmMessage: "La solicitud fué enviada satisfactoriamente. Los datos serán tendrán efecto en 72hs."
        },
        joinUs: {
            heroTitle: "Unite a la Revolución Adme",
            heroSubtitle: "🚀 Formá parte del cambio que está transformando el marketing digital. Conectá, creá y crecé con nosotros para llevar tu talento y nuestra comunidad a un nuevo nivel. ¡Tu oportunidad comienza acá! ✨",
            positions: {
                influencer: {
                    title: "Inf #014 Buscamos Creadores de contenido para Adme",
                    description: `<p>🔥 <strong>¿Listo para revolucionar el marketing digital?</strong> En <strong>Adme</strong> estamos transformando la forma en que las marcas conectan con sus audiencias — ¡y queremos que VOS seas parte!</p><p> Buscamos personas creativas, frescas, con habilidades para comunicar en video, para sumarse a Jazmín y a nuestro equipo de comunicación. Queremos que nos ayuden a contar qué es Adme, cómo evoluciona, compartir todas las actualizaciones e incentivar a usuarios y marcas a unirse a la plataforma. Ya sea que tenés un camino recorrido y querés crecer como creador UGC, o estás comenzando a construir tu influencia, tenemos <strong>varias posiciones abiertas</strong> para que muestres tu estilo único.</p>
                    <h5>¿Quién debería postularse?</h5>
                    <ul>
                        <li>🌟 Creadores apasionados por contar historias y generar contenido que realmente conecte.</li>
                        <li>🚀 Talentos emergentes con ganas de crecer y dejar huella en el mundo influencer.</li>
                        <li>🎯 Cualquier persona lista para crear posts genuinos y atractivos que resuenen con un público joven y vibrante.</li>
                    </ul>
                    <h5>¿Qué ofrecemos? 🎁</h5>
                    <ul>
                        <li>💸 Pago por contenido (por reel, historia, posteo, etc.)</li>
                        <li>💰 Bonificaciones por contenido que genere nuevos leads.</li>
                        <li>📢 Posibilidad de ser creador recurrente de Adme.</li>
                    </ul>`,
                    hiringProcessTitle: "¿Cómo aplicar?",
                    hiringProcessDetails: ` <ul>
                                            <li>🎥 Grabá dos videos y subilos a la nube:
                                                <ul>
                                                <li>🕒1. Contanos en menos de un minuto por qué querés ser parte de Adme.</li>
                                                <li>🎬2. Replicá o dale tu toque, a <a href="https://adme.com.ar/assets/img/videoJazDeEjemplo.mp4" target="_blank" rel="noopener noreferrer">este video ejemplo</a></li>
                                                </ul>
                                            </li>
                                            </ul>
                                            <p>Envía los links junto con tus perfiles en redes sociales (Instagram, TikTok, Facebook, etc.) a <a href="mailto:gaston@adme.com.ar">gaston@adme.com.ar</a> con la referencia Inf #014 y tu nombre en el asunto.<p>
                                            <p>Revisaremos todas las postulaciones y te responderemos en una semana. Si quedas seleccionada/o, coordinaremos una reunión para comenzar con tu primer encargo y arrancar esta aventura.</p>
                                            <p><strong>¡Sé parte de la revolución global de Adme y deja que tu voz se escuche! 🌍🚀</strong></p>
                                            `,
                    date: "1 de Julio, 2025",
                    tags: "Creador de Contenido | Influencer",
                    positionsAvailable: "10 posiciones abiertas"
                },

                brandAmbassador: {
                    title: "Emb #011 Sé Embajador o Embajadora de marcas en Adme y hacé crecer esta Revolución! 🌟",
                    description: `
                        <p>¿Ya creás contenido para marcas? ¿Trabajás con agencias o sos parte de comunidades de marcas que podrían sumarse a Adme? Entonces esta oportunidad es para vos.</p>
                        <p>En <strong>Adme</strong>, buscamos <strong>Embajadores y Embajadoras de marcas</strong> con redes y pasión por conectar marcas y agencias con nuestra plataforma revolucionaria. Ya seas influencer, trabajes con agencias o incluso seas una marca conectada con otras, ¡unite a la comunidad que está cambiando las reglas del juego!</p>
                        <h5>¿A quién invitamos a sumarse?</h5>
                        <ul>
                            <li>✨ Creás contenido para marcas y querés ayudarnos a sumarlas a Adme.</li>
                            <li>🤝 Trabajás con agencias que podrían beneficiarse de nuestra plataforma.</li>
                            <li>🏢 Representas a una marca que participa en comunidades o redes interesada en nuevas oportunidades.</li>
                            <li>🌍 Tenés contactos con potencial para hacer crecer esta increíble red.</li>
                        </ul>
                        <h5>¿Qué ofrecemos?💰 🎁</h5>
                        <ul>
                            <li>💰 <strong>$100.000</strong> por cada marca o agencia que llegue a una reunión con nosotros interesada en sumarse a Adme.</li>
                            <li>💸 <strong>15% de comisión</strong> sobre el presupuesto de las primeras 3 campañas de cada marca o agencia que traigas.</li>
                            <li>📣 Menciones especiales en nuestra cuenta oficial de Instagram para potenciar tu perfil y acelerar tu alcance.</li>
                            <li>🎉 10 referidos de regalo para impulsar tu red desde el comienzo.</li>
                            <li>🎟️ Acceso prioritario a eventos exclusivos y capacitaciones para potenciar tu crecimiento.</li>
                        </ul>
                        `,
                    hiringProcessTitle: "¿Cómo aplicar? ✉️",
                    hiringProcessDetails: `
                        <p>Enviá un correo a <a href="mailto:gaston@adme.com.ar">gaston@adme.com.ar</a> con la referencia Emb #011 y tu nombre en el asunto. Compartinos tus perfiles de Instagram, Facebook, TikTok o las redes que uses. Contanos por qué creés que serías un gran Embajador de marcas para Adme.</p>
                        <p>Desde ahí, nos pondremos en contacto para crear una estrategia personalizada y empezar a sumar marcas y agencias a esta gran revolución.</p>
                        <p><strong>¡Unite y hagamos historia juntos! 💥</strong></p>
                        `,
                    date: "1 de Julio, 2025",
                    tags: "Embajador de Marca | Alianzas",
                    positionsAvailable: "Varias posiciones abiertas"
                }
            }
        }
    }
};